function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { VideoColourSpace as ClientVideoColourSpace } from '@sky-uk-ott/client-lib-js-device';
import { AddonManager } from '../../addons/addon-manager';
import { shouldLoadAdvertisingAddons } from '../../addons/adverts/ad-provider-selection';
import { AdBreakType, SsaiStitcherType } from '../../addons/adverts/common';
import { CoreVideoInternal } from '../../core-video-internal';
import { AddonErrorCategory, CvsdkError, ErrorReason, ErrorSeverity, PlayerErrorCategory } from '../../error';
import { sdkLogger } from '../../logger';
import { JsonUtils } from '../../utils/json-utils';
import { CompositeObservable } from '../../utils/observables/composite-observable';
import { OBSERVABLE_IGNORE_EVENT, createErrorLogger } from '../../utils/observables/observable';
import { createLoggingObservable } from '../../utils/observables/verbose-logging-observable';
import { PerfKey, perfLogger, PerfTag } from '../../utils/perf';
import { checkIsManifestLinearType, checkIsManifestSingleLiveEventType, checkIsManifestVodType } from '../../utils/playback-type';
import { TimedLock } from '../../utils/timed-lock';
import { AudioFormat } from '../player/audio-format';
import { PlayerState } from '../player/player-state';
import { isSleCsai, PlaybackType, PlayoutDataError, isMultiplayerCsai } from '../player/playout-data';
import { VideoColourSpace, VideoFormat } from '../player/video-format';
import { TelemetryNotificationKey, TelemetrySession } from '../telemetry/telemetry-session';
import { SeekingManager } from './seeking-manager/seeking-manager';
import { PinRequiredCause } from './session-controller';
import { TimelineItemType } from './timeline/timeline';
import { TimelineManager } from './timeline/timeline-manager';
import { InternalSessionState, INITIAL_STATES, FINAL_STATES } from './internal-session-state';
import { BitrateCapManager, BitrateCapReason } from '../meta-list-manager/bitrate-cap-manager';
import { TestingOverrides } from '../services/testing-overrides';
import { CommonEventTrack, EventTrackType, VideoElementEventTrack } from '../events/event-track';
import { EventManager } from '../events/event-manager';
import { MetaListManager } from '../meta-list-manager/meta-list-manager';
import { LiveActionManager } from '../meta-list-manager/live-action-manager';
import { ObserverPriority } from '../../utils/observables/observable.enums';
import { absoluteDateToContentTime, contentTimeToAbsoluteDate } from '../../utils/live-window-utils';
export var COLOUR_SPACE_ACTIVATION_ERROR_PREFIX = 'SESSION.ACTIVATE_COLOUR_SPACE_FAILED';
var _obj;
var PLAYOUT_ERROR_TO_PIN_CAUSE = (_obj = {}, _define_property(_obj, PlayoutDataError.PARENTAL_PIN_REQUIRED, PinRequiredCause.Required), _define_property(_obj, PlayoutDataError.INVALID_PIN_PROVIDED, PinRequiredCause.Invalid), _define_property(_obj, PlayoutDataError.PIN_SERVICE_DOWN, PinRequiredCause.PinServiceDown), _obj);
// Given to us by the player which gives us the hard limits, (surrounds the seekableRange which is a smaller window with built in tolerance)
/** Stream position specified by the player. */ /**
 * @public
 * A window of time in which we are able to seek forwards or backwards through the content
 */ // The stream position of the seekable range start
// The stream position of the seekable range end
// The dateTime corresponding with the stream start position in the current seekable range
// The dateTime corresponding with the stream start position in the current seekable range
/**
 * @public
 */ /** Content time */ /** Absolute date time (live content only)  */ /** A smaller window inside the live window that has some built in tolerance (live content only) */ /** Whether or not the player position is at the live edge (live content only) */ export var SessionControllerInternal = /*#__PURE__*/ function() {
    "use strict";
    function SessionControllerInternal(playerEngine, config, videoPlatformIntegration, sessionControllerPrecursor, addonsFactories, hdcpManager) {
        var _this = this;
        _class_call_check(this, SessionControllerInternal);
        var _this1 = this;
        var _this_config_metalist_liveActions, _this_config_metalist;
        _define_property(this, "playerEngine", void 0);
        _define_property(this, "config", void 0);
        _define_property(this, "sessionControllerPrecursor", void 0);
        _define_property(this, "hdcpManager", void 0);
        _define_property(this, "addonManager", void 0);
        _define_property(this, "currentPlayerItem", void 0);
        _define_property(this, "currentTimelineItem", void 0);
        _define_property(this, "currentState", void 0);
        _define_property(this, "sessionItem", void 0);
        _define_property(this, "logger", void 0);
        _define_property(this, "telemetryObservable", void 0);
        _define_property(this, "telemetryUpdateObservable", void 0);
        _define_property(this, "httpRequestObservable", void 0);
        _define_property(this, "httpResponseObservable", void 0);
        _define_property(this, "sessionStateObservable", void 0);
        _define_property(this, "playStartObservable", void 0);
        _define_property(this, "rebufferStartObservable", void 0);
        _define_property(this, "rebufferEndObservable", void 0);
        _define_property(this, "errorObservable", void 0);
        _define_property(this, "warningObservable", void 0);
        _define_property(this, "adPositionObservable", void 0);
        _define_property(this, "streamMetadataReceivedObservable", void 0);
        _define_property(this, "timedMetadataReceivedObservable", void 0);
        _define_property(this, "bulkTimedMetadataReceivedObservable", void 0);
        _define_property(this, "bitrateChangedObservable", void 0);
        _define_property(this, "encodedFrameRateChangedObservable", void 0);
        _define_property(this, "renderedFrameRateChangedObservable", void 0);
        _define_property(this, "videoTrackChangedObservable", void 0);
        _define_property(this, "availableAudioTracksChangedObservable", void 0);
        _define_property(this, "availableSubtitlesTracksChangedObservable", void 0);
        _define_property(this, "availableThumbnailVariantsChangedObservable", void 0);
        _define_property(this, "audioTrackWillChangeObservable", void 0);
        _define_property(this, "audioTrackChangedObservable", void 0);
        _define_property(this, "bitrateCapChangedObservable", void 0);
        _define_property(this, "bitrateCapRequestedObservable", void 0);
        _define_property(this, "playoutDataObservable", void 0);
        _define_property(this, "playoutRulesObservable", void 0);
        _define_property(this, "subtitlesTrackChangedObservable", void 0);
        _define_property(this, "subtitleCuesChangedObservable", void 0);
        _define_property(this, "volumeChangedObservable", void 0);
        _define_property(this, "isMutedObservable", void 0);
        _define_property(this, "adStartedObservable", void 0);
        _define_property(this, "adFinishedObservable", void 0);
        _define_property(this, "adBreakStartedObservable", void 0);
        _define_property(this, "adBreakFinishedObservable", void 0);
        _define_property(this, "adBreakDataReceivedObservable", void 0);
        _define_property(this, "adTrackingReceivedObservable", void 0);
        _define_property(this, "catchupSeekObservable", void 0);
        _define_property(this, "qualityFailoverObservable", void 0);
        _define_property(this, "cdnSwitchObservable", void 0);
        _define_property(this, "manifestReceivedObservable", void 0);
        _define_property(this, "pauseAdObservable", void 0);
        _define_property(this, "companionAdInsertionEnabledObservable", void 0);
        _define_property(this, "companionAdOpportunityStartedObservable", void 0);
        _define_property(this, "companionAdOpportunityEndedObservable", void 0);
        _define_property(this, "renderWatermarkObservable", void 0);
        _define_property(this, "clearWatermarkObservable", void 0);
        _define_property(this, "clearWatermarksObservable", void 0);
        _define_property(this, "assetMetadataUpdateObservable", void 0);
        _define_property(this, "playbackTimelineObservable", void 0);
        _define_property(this, "videoElementCreatedObservable", void 0);
        _define_property(this, "fullscreenChangedObservable", void 0);
        _define_property(this, "clickedObservable", void 0);
        _define_property(this, "timelineManager", void 0);
        _define_property(this, "seekingManager", void 0);
        _define_property(this, "playerBitrateLimits", void 0);
        _define_property(this, "sessionEndedObservable", void 0);
        _define_property(this, "userWaitStartedObservable", void 0);
        _define_property(this, "userWaitEndedObservable", void 0);
        _define_property(this, "eventBoundaryObservable", void 0);
        _define_property(this, "endOfEventMarkerReceivedObservable", void 0);
        _define_property(this, "pinRequiredObservable", void 0);
        _define_property(this, "autoPlayPolicyPreventedPlaybackObservable", void 0);
        _define_property(this, "pinSuccessObservable", void 0);
        _define_property(this, "isWaitingForPin", void 0);
        _define_property(this, "advertsManager", void 0);
        _define_property(this, "isListeningForVST", void 0);
        _define_property(this, "startPositionMoved", void 0);
        _define_property(this, "preSeekLock", void 0);
        _define_property(this, "hasSeekedFromLiveEdge", void 0);
        _define_property(this, "isFirstLoadingStateSet", void 0);
        _define_property(this, "eventManager", void 0);
        _define_property(this, "cachedEngineItemDuration", void 0);
        _define_property(this, "telemetrySession", void 0);
        _define_property(this, "bitrateCapManager", void 0);
        _define_property(this, "metaListManager", void 0);
        _define_property(this, "liveActionManager", void 0);
        _define_property(this, "liveActionsStarted", void 0);
        _define_property(this, "getLiveWindow", void 0);
        _define_property(this, "notifyLiveWindowUpdate", void 0);
        _define_property(this, "notifyAvailableAudioTracksChanged", void 0);
        _define_property(this, "notifyAvailableSubtitlesTracksChanged", void 0);
        _define_property(this, "notifyCurrentSubtitlesTrackChanged", void 0);
        _define_property(this, "notifyAvailableThumbnailVariantsChanged", void 0);
        _define_property(this, "updatePlayerStartPosition", void 0);
        _define_property(this, "attemptToCreatePlaybackTimeline", void 0);
        _define_property(this, "handlePlayerStateChange", void 0);
        _define_property(this, "isInCSAIPreRoll", void 0);
        _define_property(this, "handlePositionChange", void 0);
        _define_property(this, "handleDurationChange", void 0);
        _define_property(this, "handlePreSeekStarted", void 0);
        _define_property(this, "handlePreSeekEnded", void 0);
        _define_property(this, "handleSeekStarted", void 0);
        _define_property(this, "handleSeekEnded", void 0);
        _define_property(this, "handleManifestUpdated", void 0);
        _define_property(this, "registerPlayerObservers", void 0);
        _define_property(this, "handleVideoElementCreated", void 0);
        _define_property(this, "createManifestReceivedHandler", void 0);
        this.playerEngine = playerEngine;
        this.config = config;
        this.sessionControllerPrecursor = sessionControllerPrecursor;
        this.hdcpManager = hdcpManager;
        this.currentState = InternalSessionState.Initialized;
        this.logger = sdkLogger.withContext('SCI');
        this.telemetryObservable = createLoggingObservable('TelemetryObservable', this.logger);
        this.telemetryUpdateObservable = createLoggingObservable('telemetryUpdateObservable', this.logger);
        this.httpRequestObservable = createLoggingObservable('HttpRequestObservable', this.logger);
        this.httpResponseObservable = createLoggingObservable('HttpResponseObservable', this.logger);
        this.sessionStateObservable = createLoggingObservable('SessionState', this.logger);
        this.playStartObservable = createLoggingObservable('PlayStart', this.logger);
        this.rebufferStartObservable = createLoggingObservable('BufferingStarted', this.logger);
        this.rebufferEndObservable = createLoggingObservable('BufferingEnded', this.logger);
        this.errorObservable = createLoggingObservable('Error', this.logger);
        this.warningObservable = createLoggingObservable('Warning', this.logger);
        this.adPositionObservable = createLoggingObservable('AdPositionChanged', this.logger);
        this.streamMetadataReceivedObservable = createLoggingObservable('StreamMetadataReceived', this.logger);
        this.timedMetadataReceivedObservable = createLoggingObservable('TimedMetadataReceived', this.logger);
        this.bulkTimedMetadataReceivedObservable = createLoggingObservable('BulkTimedMetadataReceived', this.logger);
        this.bitrateChangedObservable = createLoggingObservable('BitrateChanged', this.logger);
        this.encodedFrameRateChangedObservable = createLoggingObservable('EncodedFrameRateChanged', this.logger);
        this.renderedFrameRateChangedObservable = createLoggingObservable('RenderedFrameRateChanged', this.logger);
        this.videoTrackChangedObservable = createLoggingObservable('VideoTrackChanged', this.logger);
        this.availableAudioTracksChangedObservable = createLoggingObservable('AvailableAudioTracksChanged', this.logger);
        this.availableSubtitlesTracksChangedObservable = createLoggingObservable('AvailableSubtitlesTracksChanged', this.logger);
        this.availableThumbnailVariantsChangedObservable = createLoggingObservable('AvailableThumbnailVariantsChanged', this.logger);
        this.audioTrackWillChangeObservable = createLoggingObservable('AudioTrackWillChange', this.logger);
        this.audioTrackChangedObservable = createLoggingObservable('AudioTrackChanged', this.logger);
        this.bitrateCapChangedObservable = createLoggingObservable('BitrateCapChanged', this.logger);
        this.bitrateCapRequestedObservable = createLoggingObservable('BitrateCapChanged', this.logger);
        this.playoutDataObservable = createLoggingObservable('PlayoutDataReceived', this.logger);
        this.playoutRulesObservable = createLoggingObservable('PlayoutRulesReceived', this.logger);
        this.subtitlesTrackChangedObservable = createLoggingObservable('SubtitlesTrackChanged', this.logger);
        this.subtitleCuesChangedObservable = createLoggingObservable('SubtitleCuesChanged', this.logger);
        this.volumeChangedObservable = createLoggingObservable('VolumeChanged', this.logger);
        this.isMutedObservable = createLoggingObservable('MuteChanged', this.logger);
        this.adStartedObservable = createLoggingObservable('AdStarted', this.logger);
        this.adFinishedObservable = createLoggingObservable('AdFinished', this.logger);
        this.adBreakStartedObservable = createLoggingObservable('AdBreakStarted', this.logger);
        this.adBreakFinishedObservable = createLoggingObservable('AdBreakFinished', this.logger);
        this.adBreakDataReceivedObservable = createLoggingObservable('AdBreakDataReceived', this.logger);
        this.adTrackingReceivedObservable = createLoggingObservable('AdTrackingReceived', this.logger);
        this.catchupSeekObservable = createLoggingObservable('CatchupSeek', this.logger);
        this.qualityFailoverObservable = createLoggingObservable('QualityFailover', this.logger);
        this.cdnSwitchObservable = createLoggingObservable('CdnSwitch', this.logger);
        this.manifestReceivedObservable = createLoggingObservable('ManifestReceived', this.logger);
        this.pauseAdObservable = createLoggingObservable('PauseAd', this.logger);
        this.companionAdInsertionEnabledObservable = createLoggingObservable('CompanionAdInsertionEnabled', this.logger);
        this.companionAdOpportunityStartedObservable = createLoggingObservable('CompanionAdOpportunityStarted', this.logger);
        this.companionAdOpportunityEndedObservable = createLoggingObservable('CompanionAdOpportunityEnded', this.logger);
        this.renderWatermarkObservable = createLoggingObservable('RenderWatermark', this.logger);
        this.clearWatermarkObservable = createLoggingObservable('ClearWatermark', this.logger);
        this.clearWatermarksObservable = createLoggingObservable('ClearWatermarks', this.logger);
        this.assetMetadataUpdateObservable = createLoggingObservable('AssetMetadata', this.logger);
        this.videoElementCreatedObservable = createLoggingObservable('VideoElementCreated', this.logger);
        this.fullscreenChangedObservable = createLoggingObservable('FullscreenChanged', this.logger);
        this.clickedObservable = createLoggingObservable('Clicked', this.logger);
        this.sessionEndedObservable = createLoggingObservable('SessionEnded', this.logger);
        this.userWaitStartedObservable = createLoggingObservable('UserWaitStarted', this.logger);
        this.userWaitEndedObservable = createLoggingObservable('UserWaitEnded', this.logger);
        this.eventBoundaryObservable = createLoggingObservable('EventBoundary', this.logger);
        this.endOfEventMarkerReceivedObservable = createLoggingObservable('EndOfEventMarkerReceived', this.logger);
        this.pinRequiredObservable = createLoggingObservable('PinRequired', this.logger);
        this.autoPlayPolicyPreventedPlaybackObservable = createLoggingObservable('AutoPlayPolicyPreventedPlayback', this.logger);
        this.pinSuccessObservable = createLoggingObservable('PinSuccess', this.logger);
        this.isListeningForVST = true;
        this.startPositionMoved = false;
        this.preSeekLock = new TimedLock({
            lockTimeMs: 3000
        });
        this.hasSeekedFromLiveEdge = false;
        this.isFirstLoadingStateSet = false;
        this.eventManager = null;
        this.liveActionsStarted = false;
        this.getLiveWindow = /*#__PURE__*/ _async_to_generator(function() {
            var _this_currentPlayerItem, _this_currentTimelineItem, _this_currentPlayerItem1;
            return _ts_generator(this, function(_state) {
                if (_this1.isBlockingUserInput() || !((_this_currentPlayerItem = _this1.currentPlayerItem) === null || _this_currentPlayerItem === void 0 ? void 0 : _this_currentPlayerItem.isActive())) {
                    _this1.logger.warn('SDK.SESSION.GET_LIVE_WINDOW.INVALID_STATE');
                    return [
                        2,
                        null
                    ];
                }
                if (((_this_currentTimelineItem = _this1.currentTimelineItem) === null || _this_currentTimelineItem === void 0 ? void 0 : _this_currentTimelineItem.type) !== TimelineItemType.MainContent) {
                    return [
                        2,
                        null
                    ];
                }
                return [
                    2,
                    ((_this_currentPlayerItem1 = _this1.currentPlayerItem) === null || _this_currentPlayerItem1 === void 0 ? void 0 : _this_currentPlayerItem1.getLiveWindow()) || null
                ];
            });
        });
        this.notifyLiveWindowUpdate = function(liveWindow) {
            if (!liveWindow) {
                return;
            }
            var modifiedSeekableRange = _this.seekingManager.adjustLiveWindow(liveWindow);
            _this.playbackTimelineObservable.notifyObservers({
                liveWindow: liveWindow,
                seekableRange: modifiedSeekableRange
            });
        };
        this.notifyAvailableAudioTracksChanged = function(audioTracks) {
            var filteredAudioTracks = _this.addonManager.filterAudioTracks(audioTracks);
            _this.availableAudioTracksChangedObservable.notifyObservers(filteredAudioTracks);
        };
        this.notifyAvailableSubtitlesTracksChanged = function(subtitlesTracks) {
            var filteredSubtitlesTracks = _this.addonManager.filterSubtitlesTracks(subtitlesTracks);
            _this.availableSubtitlesTracksChangedObservable.notifyObservers(filteredSubtitlesTracks);
        };
        this.notifyCurrentSubtitlesTrackChanged = function(track) {
            var _this_currentPlayerItem;
            (_this_currentPlayerItem = _this.currentPlayerItem) === null || _this_currentPlayerItem === void 0 ? void 0 : _this_currentPlayerItem.notifySubtitleCuesReset();
            _this.subtitlesTrackChangedObservable.notifyObservers(track);
        };
        this.notifyAvailableThumbnailVariantsChanged = function(thumbnailVariants) {
            _this.availableThumbnailVariantsChangedObservable.notifyObservers(thumbnailVariants);
        };
        this.updatePlayerStartPosition = function() {
            var _this_config_addons_adInsertion_adPolicyConfig, _this_config_addons_adInsertion, _this_sessionControllerPrecursor_playoutData;
            // Note: need to permit seeks after VST for alwaysForcePrerolls. There is a risk of Playing state starting before ads are received
            var alwaysForcePrerolls = (_this_config_addons_adInsertion = _this.config.addons.adInsertion) === null || _this_config_addons_adInsertion === void 0 ? void 0 : (_this_config_addons_adInsertion_adPolicyConfig = _this_config_addons_adInsertion.adPolicyConfig) === null || _this_config_addons_adInsertion_adPolicyConfig === void 0 ? void 0 : _this_config_addons_adInsertion_adPolicyConfig.alwaysForcePrerolls;
            if ((_this.isListeningForVST || alwaysForcePrerolls) && typeof ((_this_sessionControllerPrecursor_playoutData = _this.sessionControllerPrecursor.playoutData) === null || _this_sessionControllerPrecursor_playoutData === void 0 ? void 0 : _this_sessionControllerPrecursor_playoutData.position) === 'number' && !_this.startPositionMoved && checkIsManifestVodType(_this.sessionItem.type) && _this.advertsManager.isInitialPositionAdjustmentRequired()) {
                _this.seekingManager.seekToAdjustedStartPosition(_this.sessionControllerPrecursor.playoutData.position);
                _this.startPositionMoved = true;
            }
        };
        this.attemptToCreatePlaybackTimeline = function(param) {
            var position = param.position, currentTime = param.currentTime, absolutePosition = param.absolutePosition, seekableRange = param.seekableRange, liveWindow = param.liveWindow, suppressTimelineUpdatesForClients = param.suppressTimelineUpdatesForClients;
            if (!position && position !== 0) {
                return null;
            }
            if (checkIsManifestLinearType(_this.sessionItem.type)) {
                if (!CoreVideoInternal.playerCapabilities.isLinearScrubbingSupported) {
                    return {
                        state: {
                            position: position,
                            currentTime: currentTime,
                            absolutePosition: absolutePosition,
                            liveWindow: liveWindow
                        }
                    };
                }
                var isAtLiveEdge = seekableRange && _this.calculateIfAtLiveEdge(seekableRange, position);
                _this.calculateUserSeekedFromLiveEdge(!!isAtLiveEdge);
                return {
                    state: {
                        liveWindow: liveWindow,
                        seekableRange: seekableRange,
                        position: position,
                        currentTime: currentTime,
                        absolutePosition: absolutePosition,
                        isAtLiveEdge: isAtLiveEdge,
                        suppressTimelineUpdatesForClients: suppressTimelineUpdatesForClients
                    }
                };
            }
            return {
                state: {
                    seekableRange: seekableRange,
                    position: position,
                    currentTime: currentTime,
                    suppressTimelineUpdatesForClients: suppressTimelineUpdatesForClients
                }
            };
        };
        this.handlePlayerStateChange = function(state) {
            var playoutData = _this.sessionControllerPrecursor.playoutData;
            switch(state){
                case PlayerState.Loading:
                    {
                        if (playoutData && isSleCsai(playoutData) && _this.isFirstLoadingStateSet) {
                            _this.setSessionState(InternalSessionState.CsaiTransition);
                        } else {
                            _this.setSessionState(InternalSessionState.PlayerLoading);
                            _this.isFirstLoadingStateSet = true;
                        }
                        if (playoutData && _this.isMainContentCsai(playoutData)) {
                            _this.isListeningForVST = true;
                        }
                        break;
                    }
                case PlayerState.Paused:
                    _this.handleRebufferEnd();
                    if (_this.isListeningForVST) {
                        perfLogger.measure(PerfKey.root, PerfTag.videoStartup);
                        _this.telemetryUpdateObservable.notifyObservers({
                            key: TelemetryNotificationKey.videoStartUp,
                            value: new Date().getTime()
                        });
                        _this.isListeningForVST = false;
                    }
                    _this.setSessionState(InternalSessionState.Paused);
                    _this.updatePlayerStartPositionForForcedPrerolls();
                    break;
                case PlayerState.Playing:
                    _this.handleRebufferEnd();
                    if (_this.isListeningForVST) {
                        perfLogger.measure(PerfKey.root, PerfTag.videoStartup);
                        _this.telemetryUpdateObservable.notifyObservers({
                            key: TelemetryNotificationKey.videoStartUp,
                            value: new Date().getTime()
                        });
                        _this.isListeningForVST = false;
                        if (playoutData && _this.isMainContentCsai(playoutData)) {
                            perfLogger.measure(PerfKey.root, PerfTag.videoStartupMainContent);
                        }
                    }
                    _this.setSessionState(InternalSessionState.Playing);
                    _this.updatePlayerStartPositionForForcedPrerolls();
                    break;
                case PlayerState.Rebuffering:
                    {
                        if (_this.currentState !== InternalSessionState.Rebuffering) {
                            perfLogger.measure(PerfKey.playerState, PerfTag.rebufferStart);
                            _this.notifyRebufferStart();
                        }
                        _this.setSessionState(InternalSessionState.Rebuffering);
                        break;
                    }
                case PlayerState.Seeking:
                    {
                        if (_this.currentState !== InternalSessionState.Seeking) {
                            perfLogger.measure(PerfKey.playerState, PerfTag.seekStart);
                        }
                        _this.handlePreSeekEnded();
                        _this.setSessionState(InternalSessionState.Seeking);
                        break;
                    }
                default:
            }
        };
        this.isInCSAIPreRoll = function() {
            var currentAdBreak = _this.advertsManager.getCurrentAdBreak();
            if (!currentAdBreak || !CoreVideoInternal.playerCapabilities.supportsNativeCsai) {
                return false;
            }
            return currentAdBreak.type === AdBreakType.Preroll && currentAdBreak.ssaiStitcherType === SsaiStitcherType.None;
        };
        this.handlePositionChange = /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function(timeIncludingAds) {
                var _this_currentPlayerItem, contentTime, timeline, _this_currentPlayerItem1, _ref, liveWindow, absolutePosition, timeline1;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _this1.advertsManager.handlePositionChange(timeIncludingAds);
                            if (!checkIsManifestVodType(_this1.sessionItem.type)) return [
                                3,
                                1
                            ];
                            contentTime = _this1.advertsManager.timeIncludingAdsToContentTime(timeIncludingAds);
                            timeline = {
                                position: contentTime,
                                currentTime: timeIncludingAds
                            };
                            /**
             * Android/exo player CVSDK receives only one timeline but with pre roll in it
             * Thus not reporting position of a pre-roll to keep similar behavior to other players who produce separate timeline events for ads and main content
             */ timeline.suppressTimelineUpdatesForClients = _this1.isInCSAIPreRoll() ? true : false;
                            _this1.playbackTimelineObservable.notifyObservers(timeline, (_this_currentPlayerItem = _this1.currentPlayerItem) === null || _this_currentPlayerItem === void 0 ? void 0 : _this_currentPlayerItem.getCurrentPosition());
                            return [
                                3,
                                3
                            ];
                        case 1:
                            /**
             * On Android, CSAI ads are part of the main timeline.
             * We don't start LiveActions until we know CSAI Prerolls are complete.
             */ _this1.tryEnableLiveActions(_this1.currentPlayerItem);
                            return [
                                4,
                                _this1.getLiveWindow()
                            ];
                        case 2:
                            liveWindow = (_ref = _state.sent()) !== null && _ref !== void 0 ? _ref : undefined;
                            absolutePosition = contentTimeToAbsoluteDate(timeIncludingAds, liveWindow);
                            timeline1 = {
                                position: timeIncludingAds,
                                currentTime: timeIncludingAds,
                                absolutePosition: absolutePosition
                            };
                            /**
             * Android/exo player CVSDK receives only one timeline but with pre roll in it
             * Thus not reporting position of a pre-roll to keep similar behavior to other players who produce separate timeline events for ads and main content
             */ timeline1.suppressTimelineUpdatesForClients = _this1.isInCSAIPreRoll() ? true : false;
                            _this1.playbackTimelineObservable.notifyObservers(timeline1, (_this_currentPlayerItem1 = _this1.currentPlayerItem) === null || _this_currentPlayerItem1 === void 0 ? void 0 : _this_currentPlayerItem1.getCurrentPosition());
                            _state.label = 3;
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(timeIncludingAds) {
                return _ref.apply(this, arguments);
            };
        }();
        this.handleDurationChange = function(engineItemDuration) {
            if (checkIsManifestVodType(_this.sessionItem.type) && typeof _this.cachedEngineItemDuration === 'number' && _this.cachedEngineItemDuration !== engineItemDuration) {
                _this.logger.info("VOD duration changed from ".concat(_this.cachedEngineItemDuration, " to ").concat(engineItemDuration));
            }
            _this.cachedEngineItemDuration = engineItemDuration;
            _this.updateSeekableRange();
        };
        this.handlePreSeekStarted = function() {
            _this.logger.verbose('Pre-Seek started');
            _this.preSeekLock.lock();
        };
        this.handlePreSeekEnded = function() {
            if (_this.preSeekLock.locked) {
                _this.preSeekLock.unlock();
            }
        };
        this.handleSeekStarted = function(timeIncludingAds) {
            _this.seekingManager.handleSeekStarted(timeIncludingAds);
        };
        this.handleSeekEnded = function() {
            _this.seekingManager.handleSeekEnded();
        };
        this.handleManifestUpdated = /*#__PURE__*/ _async_to_generator(function() {
            var _this_metaListManager;
            return _ts_generator(this, function(_state) {
                (_this_metaListManager = _this1.metaListManager) === null || _this_metaListManager === void 0 ? void 0 : _this_metaListManager.handleManifestUpdated();
                return [
                    2
                ];
            });
        });
        this.registerPlayerObservers = function(item, timelineItem) {
            if (timelineItem.type !== TimelineItemType.Advert) {
                item.onManifestUpdated(_this.handleManifestUpdated, _this);
                item.onDurationChanged(_this.handleDurationChange, _this);
                item.onLiveWindowUpdate(_this.notifyLiveWindowUpdate.bind(_this), _this);
                item.onPositionChanged(_this.handlePositionChange, _this);
                item.onPreSeekStarted(_this.handlePreSeekStarted, _this);
                item.onSeekStarted(_this.handleSeekStarted, _this);
                item.onSeekEnded(_this.handleSeekEnded, _this);
                item.onManifestParsed(_this.handleManifestParsed, _this);
                item.onAvailableAudioTracksChanged(_this.notifyAvailableAudioTracksChanged, _this);
                item.onAvailableSubtitlesTracksChanged(_this.notifyAvailableSubtitlesTracksChanged, _this);
                item.onAvailableThumbnailVariantsChanged(_this.notifyAvailableThumbnailVariantsChanged, _this);
                item.onStreamMetadataReceived(_this.handlePlayerEvent.bind(_this, _this.streamMetadataReceivedObservable), _this);
                item.onTimedMetadataReceived(_this.handlePlayerEvent.bind(_this, _this.timedMetadataReceivedObservable), _this);
                if (CoreVideoInternal.playerCapabilities.emitsBulkTimedMetadata) {
                    item.onBulkTimedMetadataReceived(_this.handlePlayerEvent.bind(_this, _this.bulkTimedMetadataReceivedObservable), _this);
                }
                item.onAudioTrackChanged(_this.handlePlayerEvent.bind(_this, _this.audioTrackChangedObservable), _this);
                item.onSubtitlesTrackChanged(_this.handlePlayerEvent.bind(_this, _this.subtitlesTrackChangedObservable), _this);
                item.onSubtitleCuesChanged(_this.handlePlayerEvent.bind(_this, _this.subtitleCuesChangedObservable), _this);
                item.onEncodedFrameRateChanged(_this.handlePlayerEvent.bind(_this, _this.encodedFrameRateChangedObservable), _this);
                item.onRenderedFrameRateChanged(_this.handlePlayerEvent.bind(_this, _this.renderedFrameRateChangedObservable), _this);
                item.onHttpRequestChanged(_this.handlePlayerEvent.bind(_this, _this.httpRequestObservable), _this);
                item.onHttpResponseChanged(_this.handlePlayerEvent.bind(_this, _this.httpResponseObservable), _this);
                item.onVideoElementCreated(_this.handleVideoElementCreated, _this);
                item.onFullscreenChanged(_this.handlePlayerEvent.bind(_this, _this.fullscreenChangedObservable), _this);
                item.onClicked(_this.handlePlayerEvent.bind(_this, _this.clickedObservable), _this);
            }
            item.onWarning(_this.handleErrorReceived.bind(_this, _this.warningObservable), _this);
            item.onPlayStart(_this.notifyPlayStart.bind(_this), _this);
            item.onStateChanged(_this.handlePlayerStateChange, _this, ObserverPriority.HIGH);
            item.onBitrateChanged(_this.handlePlayerEvent.bind(_this, _this.bitrateChangedObservable), _this);
            item.onVideoTrackChanged(_this.handlePlayerEvent.bind(_this, _this.videoTrackChangedObservable), _this);
            item.onVolumeChanged(_this.handlePlayerEvent.bind(_this, _this.volumeChangedObservable), _this);
            item.onMuteChanged(_this.handlePlayerEvent.bind(_this, _this.isMutedObservable), _this);
            item.onCdnSwitch(_this.handlePlayerEvent.bind(_this, _this.cdnSwitchObservable), _this);
            item.onAutoPlayPolicyPreventedPlayback(_this.notifyAutoPlayPolicyPreventedPlayback.bind(_this), _this);
            item.onAdBreakDataReceived(_this.notifyAdBreakDataReceived.bind(_this), _this);
            item.onAdBreakFinished(_this.handleAdBreakFinished.bind(_this), _this);
            item.onAdBreakStarted(_this.handleAdBreakStarted.bind(_this), _this);
            item.onAdFinished(_this.notifyAdFinished.bind(_this), _this);
            item.onAdStarted(_this.notifyAdStarted.bind(_this), _this);
            item.onAdPositionUpdate(_this.notifyAdPositionChanged.bind(_this), _this);
            if (!timelineItem.isPreloaded) {
                item.onManifestReceived(_this.createManifestReceivedHandler(timelineItem.type), _this);
            }
        };
        this.handleVideoElementCreated = function(element) {
            var display = CoreVideoInternal.display;
            if (_this.shouldDisablePip()) {
                var _display_disablePictureInPicture;
                display === null || display === void 0 ? void 0 : (_display_disablePictureInPicture = display.disablePictureInPicture) === null || _display_disablePictureInPicture === void 0 ? void 0 : _display_disablePictureInPicture.call(display, element);
            } else {
                var _display_enablePictureInPicture;
                display === null || display === void 0 ? void 0 : (_display_enablePictureInPicture = display.enablePictureInPicture) === null || _display_enablePictureInPicture === void 0 ? void 0 : _display_enablePictureInPicture.call(display, element);
            }
            _this.videoElementCreatedObservable.notifyObservers(element);
        };
        this.createManifestReceivedHandler = function(timelineItemType) {
            return function(playerManifestReceivedEvent) {
                _this.manifestReceivedObservable.notifyObservers({
                    playerManifestReceivedEvent: playerManifestReceivedEvent,
                    timelineItemType: timelineItemType
                });
            };
        };
        this.sessionItem = sessionControllerPrecursor.sessionItem;
        this.advertsManager = sessionControllerPrecursor.getAdvertsManager();
        if (this.sessionItem.providerVariantId || TestingOverrides.metalistEndpointOverride) {
            var _this_config_metalist1;
            this.metaListManager = new MetaListManager(this.notifyWarning.bind(this), this.sessionItem.providerVariantId || '', (_this_config_metalist1 = this.config.metalist) === null || _this_config_metalist1 === void 0 ? void 0 : _this_config_metalist1.minTimeoutMs);
        }
        this.bitrateCapManager = new BitrateCapManager({
            bitrateCapRequestedObservable: this.bitrateCapRequestedObservable,
            bitrateCapChangedObservable: this.bitrateCapChangedObservable
        });
        if ((_this_config_metalist = this.config.metalist) === null || _this_config_metalist === void 0 ? void 0 : (_this_config_metalist_liveActions = _this_config_metalist.liveActions) === null || _this_config_metalist_liveActions === void 0 ? void 0 : _this_config_metalist_liveActions.enableLiveActions) {
            this.liveActionManager = new LiveActionManager();
        }
        this.addonManager = new AddonManager(config.addons, this.sessionItem, videoPlatformIntegration, this, addonsFactories);
        this.playerBitrateLimits = this.sessionItem.playerBitrateLimits || {};
        var isManifestLinearType = checkIsManifestLinearType(this.sessionItem.type);
        this.timelineManager = new TimelineManager(this.playerEngine, {
            bufferingLimit: this.config.bufferingLimit
        }, {
            playbackType: this.sessionItem.type
        }, this.sessionControllerPrecursor, this.sessionControllerPrecursor.getSessionProxy());
        sessionControllerPrecursor.onTelemetryUpdate(function(e) {
            return _this.updateTelemetryMetrics(e);
        });
        this.timelineManager.onTimelineItemStarted(function(e) {
            return _this.handleTimelineItemStarted(e);
        }, this);
        this.timelineManager.onTimelineItemPlayoutReceived(function(e) {
            return _this.notifyPlayoutDataReceived(e);
        }, this);
        this.timelineManager.onTimelineItemPlayoutRulesReceived(function(e) {
            return _this.notifyPlayoutRulesReceived(e);
        }, this);
        this.timelineManager.onTimelineItemEnded(function(e) {
            return _this.handleTimelineItemEnded();
        }, this);
        this.timelineManager.onTimelineItemPreloading(function(e) {
            return _this.handleTimelineItemPreloading(e);
        }, this);
        this.timelineManager.onTimelineEnded(function() {
            return _this.destroy();
        }, this);
        this.timelineManager.onTimelineFinished(function() {
            return _this.handleTimelineFinished();
        }, this);
        this.timelineManager.onError(function(e) {
            return _this.notifyError(e);
        }, this);
        this.timelineManager.onQualityFailover(function(e) {
            return _this.notifyQualityFailover(e);
        }, this);
        this.timelineManager.onCdnSwitch(function(e) {
            _this.advertsManager.notifyManifestLoadError(e.switchError);
            _this.notifyCdnSwitch(e);
        }, this);
        this.timelineManager.onAdBreakFinished(function(adBreak) {
            var playoutData = _this.sessionControllerPrecursor.playoutData;
            if (playoutData && isSleCsai(playoutData) && adBreak.type === AdBreakType.Preroll) {
                _this.setSessionState(InternalSessionState.CsaiTransition);
            } else {
                _this.setSessionState(InternalSessionState.Loading);
            }
            _this.notifyAdBreakFinished(adBreak);
        });
        this.playbackTimelineObservable = new CompositeObservable(// @ts-ignore
        this.attemptToCreatePlaybackTimeline, createErrorLogger('PlaybackTimelineInternal', this.logger));
        this.seekingManager = new SeekingManager(this.advertsManager, isManifestLinearType, CoreVideoInternal.playerCapabilities, this.callSeekOnTimelineManager.bind(this), this.onPlaybackTimelineUpdated.bind(this), this.onStateChanged.bind(this));
        this.errorObservable.addTransformer(this.errorTransformer.bind(this));
        this.telemetrySession = new TelemetrySession(this, config.telemetry);
        // Separated logic from telemetrySession initialize in order to send data prior initialization
        this.telemetrySession.listenToSessionEvents();
        var selectedEventTrack = this.createEventTrack(this.sessionItem.eventTrackType, CoreVideoInternal.playerCapabilities.supportsVideoElement);
        this.eventManager = new EventManager(selectedEventTrack, this.onPlaybackTimelineUpdated.bind(this), this.advertsManager);
    }
    _create_class(SessionControllerInternal, [
        {
            key: "playbackType",
            get: function get() {
                return this.sessionItem.type;
            }
        },
        {
            key: "playerVersion",
            get: function get() {
                return CoreVideoInternal.playerVersion;
            }
        },
        {
            key: "createEventTrack",
            value: // give precedence to the eventTrack specified in the referenceApp, if none was selected then
            function createEventTrack(eventTrackSpecifiedInSessionItem, playerSupportsVideoElement) {
                var eventTrackToUse;
                switch(eventTrackSpecifiedInSessionItem){
                    case EventTrackType.Default:
                        eventTrackToUse = EventTrackType.CommonEventTrack;
                        break;
                    case EventTrackType.VideoElementEventTrack:
                        eventTrackToUse = playerSupportsVideoElement ? EventTrackType.VideoElementEventTrack : EventTrackType.CommonEventTrack;
                        break;
                    default:
                        eventTrackToUse = EventTrackType.CommonEventTrack;
                        break;
                }
                this.logger.info("creating eventTrack implementation using ".concat(eventTrackToUse, " class"));
                switch(eventTrackToUse){
                    case EventTrackType.VideoElementEventTrack:
                        return new VideoElementEventTrack(this.onVideoElementCreated.bind(this), this.onStateChanged.bind(this));
                    case EventTrackType.CommonEventTrack:
                    default:
                        {
                            return new CommonEventTrack(this.onPlaybackTimelineUpdated.bind(this), this.onSeekStarted.bind(this));
                        }
                }
            }
        },
        {
            key: "start",
            value: function start() {
                var _this = this;
                return _async_to_generator(function() {
                    var e;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (_this.currentState !== InternalSessionState.Initialized) {
                                    throw new Error('SDK.SESSION.START.INVALID_STATE');
                                }
                                _this.sessionControllerPrecursor.attachSession(_this);
                                _this.setSessionState(InternalSessionState.Loading);
                                _this.logger.verbose("SDK Internal Config:\n".concat(JsonUtils.stringify(_this.config)));
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    5,
                                    ,
                                    6
                                ]);
                                perfLogger.measure(PerfKey.root, PerfTag.sessionStart);
                                _this.telemetryUpdateObservable.notifyObservers({
                                    key: TelemetryNotificationKey.sessionStart,
                                    value: new Date().getTime()
                                });
                                return [
                                    4,
                                    _this.addonManager.load(CoreVideoInternal.playerCapabilities)
                                ];
                            case 2:
                                _state.sent();
                                perfLogger.measure(PerfKey.root, PerfTag.addonsLoaded);
                                return [
                                    4,
                                    _this.initialisePrecursor()
                                ];
                            case 3:
                                _state.sent();
                                perfLogger.measure(PerfKey.root, PerfTag.sessionPrecursorInitialised);
                                return [
                                    4,
                                    _this.tryPlayout()
                                ];
                            case 4:
                                _state.sent();
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                e = _state.sent();
                                if (_instanceof(e, Error)) {
                                    _this.handleStartError(e);
                                } else {
                                    _this.logger.warn('Expected error to be instanceof Error', e);
                                    _this.handleStartError(e);
                                }
                                return [
                                    3,
                                    6
                                ];
                            case 6:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "updateCueEndTime",
            value: function updateCueEndTime(cueId, endTime) {
                if (!this.eventManager) {
                    throw new Error('SDK.EVENT.INVALID_STATE');
                }
                this.logger.verbose("Updating end time for cue ".concat(cueId, " to ").concat(endTime));
                return this.eventManager.updateEventCueEndTime(cueId, endTime);
            }
        },
        {
            key: "registerCue",
            value: function registerCue(cue) {
                var _this = this;
                if (!this.eventManager) {
                    throw new Error('SDK.EVENT.INVALID_STATE');
                }
                var isVod = checkIsManifestVodType(this.sessionItem.type);
                var cueId = this.eventManager.registerEventCue(cue);
                this.logger.verbose("Registered cue ".concat(cueId, " for cue: "), cue);
                if (isVod) {
                    return cueId;
                }
                this.getLiveWindow().then(function(liveWindow) {
                    if (!liveWindow) {
                        _this.logger.warn('Live window did not exist at the point of registering a Cue, this maybe fine, but prevents us checking the cue is being registered in the live window');
                    } else if (typeof cue.endTime === 'number' && cue.endTime < (liveWindow === null || liveWindow === void 0 ? void 0 : liveWindow.start)) {
                        _this.logger.warn("Cue registered to end at ".concat(cue.endTime, " before the start of the live window (").concat(liveWindow === null || liveWindow === void 0 ? void 0 : liveWindow.start, ")- will be almost instantly deregistered"));
                    }
                });
                return cueId;
            }
        },
        {
            key: "unregisterCue",
            value: function unregisterCue(cueId) {
                if (!this.eventManager) {
                    throw new Error('SDK.EVENT.INVALID_STATE');
                }
                var cueFound = this.eventManager.unregisterEventCue(cueId);
                return cueFound;
            }
        },
        {
            key: "onEventCueEntered",
            value: function onEventCueEntered(type, callback) {
                var _this_eventManager;
                (_this_eventManager = this.eventManager) === null || _this_eventManager === void 0 ? void 0 : _this_eventManager.onEventCueEntered(type, callback);
            }
        },
        {
            key: "onEventCueExited",
            value: function onEventCueExited(type, callback) {
                var _this_eventManager;
                (_this_eventManager = this.eventManager) === null || _this_eventManager === void 0 ? void 0 : _this_eventManager.onEventCueExited(type, callback);
            }
        },
        {
            key: "onEventCueRegistered",
            value: function onEventCueRegistered(type, callback) {
                var _this_eventManager;
                (_this_eventManager = this.eventManager) === null || _this_eventManager === void 0 ? void 0 : _this_eventManager.onEventCueRegistered(type, callback);
            }
        },
        {
            key: "onEventCueUpdated",
            value: function onEventCueUpdated(type, callback) {
                var _this_eventManager;
                (_this_eventManager = this.eventManager) === null || _this_eventManager === void 0 ? void 0 : _this_eventManager.onEventCueUpdated(type, callback);
            }
        },
        {
            key: "onEventCueUnregistered",
            value: function onEventCueUnregistered(type, callback) {
                var _this_eventManager;
                (_this_eventManager = this.eventManager) === null || _this_eventManager === void 0 ? void 0 : _this_eventManager.onEventCueUnregistered(type, callback);
            }
        },
        {
            key: "notifyTelemetry",
            value: function notifyTelemetry(telemetryEvent) {
                this.telemetryObservable.notifyObservers(telemetryEvent);
            }
        },
        {
            key: "notifyPlayStart",
            value: function notifyPlayStart() {
                var _this_currentPlayerItem;
                this.playStartObservable.notifyObservers(undefined, this.advertsManager.timeIncludingAdsToContentTime((_this_currentPlayerItem = this.currentPlayerItem) === null || _this_currentPlayerItem === void 0 ? void 0 : _this_currentPlayerItem.getCurrentPosition()));
            }
        },
        {
            key: "notifyRebufferStart",
            value: function notifyRebufferStart() {
                var _this_currentPlayerItem;
                this.rebufferStartObservable.notifyObservers(undefined, this.advertsManager.timeIncludingAdsToContentTime((_this_currentPlayerItem = this.currentPlayerItem) === null || _this_currentPlayerItem === void 0 ? void 0 : _this_currentPlayerItem.getCurrentPosition()));
            }
        },
        {
            key: "notifyRebufferEnd",
            value: function notifyRebufferEnd() {
                var _this_currentPlayerItem;
                this.rebufferEndObservable.notifyObservers(undefined, this.advertsManager.timeIncludingAdsToContentTime((_this_currentPlayerItem = this.currentPlayerItem) === null || _this_currentPlayerItem === void 0 ? void 0 : _this_currentPlayerItem.getCurrentPosition()));
            }
        },
        {
            key: "getContentTimePosition",
            value: function getContentTimePosition() {
                var _this_currentPlayerItem;
                return this.advertsManager.timeIncludingAdsToContentTime((_this_currentPlayerItem = this.currentPlayerItem) === null || _this_currentPlayerItem === void 0 ? void 0 : _this_currentPlayerItem.getCurrentPosition());
            }
        },
        {
            key: "getPrecursor",
            value: function getPrecursor() {
                return this.sessionControllerPrecursor;
            }
        },
        {
            key: "getPrefetchStage",
            value: function getPrefetchStage() {
                return this.sessionControllerPrecursor.getPrefetchStage();
            }
        },
        {
            key: "isPrefetchedSession",
            value: function isPrefetchedSession() {
                return this.sessionControllerPrecursor.isPrefetchedSession();
            }
        },
        {
            key: "getAdvertsManager",
            value: function getAdvertsManager() {
                return this.advertsManager;
            }
        },
        {
            key: "getHasSeekedFromLiveEdge",
            value: function getHasSeekedFromLiveEdge() {
                return this.hasSeekedFromLiveEdge;
            }
        },
        {
            key: "getProposition",
            value: function getProposition() {
                return this.config.proposition;
            }
        },
        {
            key: "stop",
            value: function stop() {
                var _this = this;
                return _async_to_generator(function() {
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.setSessionState(InternalSessionState.Stopping);
                                return [
                                    4,
                                    _this.timelineManager.endTimeline()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "play",
            value: function play() {
                if (this.isBlockingUserInput() || this.shouldBlockSeekingState()) {
                    this.logger.warn('SDK.SESSION.PLAY.INVALID_STATE');
                    return;
                }
                if (this.currentState !== InternalSessionState.Playing) {
                    var _this_currentPlayerItem;
                    (_this_currentPlayerItem = this.currentPlayerItem) === null || _this_currentPlayerItem === void 0 ? void 0 : _this_currentPlayerItem.play();
                }
            }
        },
        {
            key: "pause",
            value: function pause() {
                if (this.isBlockingUserInput() || this.shouldBlockSeekingState()) {
                    this.logger.warn('SDK.SESSION.PAUSE.INVALID_STATE');
                    return;
                }
                if (this.currentState !== InternalSessionState.Paused && this.currentState !== InternalSessionState.Seeking) {
                    var _this_advertsManager_getPauseAdvertDispatcher, _this_currentPlayerItem;
                    this.hasSeekedFromLiveEdge = true;
                    (_this_advertsManager_getPauseAdvertDispatcher = this.advertsManager.getPauseAdvertDispatcher()) === null || _this_advertsManager_getPauseAdvertDispatcher === void 0 ? void 0 : _this_advertsManager_getPauseAdvertDispatcher.registerUserPause();
                    (_this_currentPlayerItem = this.currentPlayerItem) === null || _this_currentPlayerItem === void 0 ? void 0 : _this_currentPlayerItem.pause();
                }
            }
        },
        {
            key: "seekToDate",
            value: function seekToDate(seekDate) {
                var _this = this;
                return _async_to_generator(function() {
                    var liveWindow, contentTime;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!_this.isSeekToDateSupported()) {
                                    _this.logger.warn('SDK.SESSION.SEEK_TO_DATE.NOT_SUPPORTED');
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    4,
                                    _this.getLiveWindow()
                                ];
                            case 1:
                                liveWindow = _state.sent();
                                if (!liveWindow) {
                                    _this.logger.warn('SDK.SESSION.SEEK_TO_DATE.NO_LIVE_WINDOW');
                                    return [
                                        2
                                    ];
                                }
                                if (!liveWindow.startDate) {
                                    _this.logger.warn('SDK.SESSION.SEEK_TO_DATE.NO_START_DATE');
                                    return [
                                        2
                                    ];
                                }
                                contentTime = absoluteDateToContentTime(seekDate, liveWindow);
                                if (!contentTime) {
                                    _this.logger.warn('Unable to calculate content time from Live Window');
                                    return [
                                        2
                                    ];
                                }
                                _this.logger.info("Seek Date: ".concat(seekDate, " translated to content time: ").concat(contentTime));
                                // Seeking manager will take care of bounding to Live Window here
                                return [
                                    2,
                                    _this.seek(contentTime)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "seek",
            value: function seek(contentTime) {
                this.hasSeekedFromLiveEdge = true;
                this.seekingManager.seek(contentTime);
            }
        },
        {
            key: "seekToLiveEdge",
            value: function seekToLiveEdge() {
                var _this = this;
                return _async_to_generator(function() {
                    return _ts_generator(this, function(_state) {
                        _this.hasSeekedFromLiveEdge = false;
                        _this.seekingManager.seekToLiveEdge();
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "seekToLiveStart",
            value: function seekToLiveStart() {
                var _this = this;
                return _async_to_generator(function() {
                    return _ts_generator(this, function(_state) {
                        _this.hasSeekedFromLiveEdge = true;
                        _this.seekingManager.seekToLiveStart();
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "isAtLiveEdge",
            value: function isAtLiveEdge(position) {
                var _this = this;
                return _async_to_generator(function() {
                    var liveWindow;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!checkIsManifestLinearType(_this.playbackType)) {
                                    return [
                                        2,
                                        false
                                    ];
                                }
                                return [
                                    4,
                                    _this.getLiveWindow()
                                ];
                            case 1:
                                liveWindow = _state.sent();
                                if (!liveWindow) {
                                    return [
                                        2,
                                        false
                                    ];
                                }
                                return [
                                    2,
                                    _this.calculateIfAtLiveEdge(liveWindow, position !== null && position !== void 0 ? position : _this.currentPlayerItem.getCurrentPosition())
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "isLinearScrubbingSupported",
            value: function isLinearScrubbingSupported() {
                return !!CoreVideoInternal.playerCapabilities.isLinearScrubbingSupported;
            }
        },
        {
            key: "setVolume",
            value: function setVolume(volume) {
                var _this_currentPlayerItem;
                if (this.isBlockingUserInput()) {
                    this.logger.warn('SDK.SESSION.SET_VOLUME.INVALID_STATE');
                    return;
                }
                (_this_currentPlayerItem = this.currentPlayerItem) === null || _this_currentPlayerItem === void 0 ? void 0 : _this_currentPlayerItem.setVolume(volume);
            }
        },
        {
            key: "setMute",
            value: function setMute(isMuted) {
                var _this_currentPlayerItem;
                if (this.isBlockingUserInput()) {
                    this.logger.warn('SDK.SESSION.SET_MUTE.INVALID_STATE');
                    return;
                }
                (_this_currentPlayerItem = this.currentPlayerItem) === null || _this_currentPlayerItem === void 0 ? void 0 : _this_currentPlayerItem.setMute(isMuted);
            }
        },
        {
            key: "setPlayerBitrateLimits",
            value: function setPlayerBitrateLimits(playerBitrateLimits) {
                this.setPlayerBitrateLimitsWithReason(playerBitrateLimits, BitrateCapReason.UserConfiguredCap);
            }
        },
        {
            key: "setPlayerBitrateLimitsWithReason",
            value: function setPlayerBitrateLimitsWithReason(playerBitrateLimits) {
                var bitrateCapReason = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : BitrateCapReason.UserConfiguredCap;
                if (this.isBlockingUserInput()) {
                    this.logger.warn('SDK.SESSION.SET_VIDEO_BITRATE_LIMITS.INVALID_STATE');
                    return;
                }
                var midStreamCappingSupported = CoreVideoInternal.playerCapabilities.canSetMidStreamPlayerBitrateLimits;
                var maxBitRateCapData = this.bitrateCapManager.getMaxBitRate(playerBitrateLimits.maxBitRate, bitrateCapReason);
                if (maxBitRateCapData.requestedCapChanged || bitrateCapReason === BitrateCapReason.UserConfiguredCap) {
                    var _playerBitrateLimits_maxBitRate;
                    this.bitrateCapManager.notifyRequestedBitrateCap({
                        value: (_playerBitrateLimits_maxBitRate = playerBitrateLimits.maxBitRate) !== null && _playerBitrateLimits_maxBitRate !== void 0 ? _playerBitrateLimits_maxBitRate : Infinity,
                        reason: bitrateCapReason
                    });
                }
                if (maxBitRateCapData.currentCapChanged) {
                    this.logger.verbose("setPlayerBitrateLimits: setting the new bitrate cap: ".concat(maxBitRateCapData.value, " / ").concat(maxBitRateCapData.reason));
                    if (midStreamCappingSupported) {
                        var _this_currentPlayerItem;
                        this.bitrateCapManager.notifyAppliedBitrateCap(maxBitRateCapData);
                        (_this_currentPlayerItem = this.currentPlayerItem) === null || _this_currentPlayerItem === void 0 ? void 0 : _this_currentPlayerItem.setPlayerBitrateLimits(_object_spread_props(_object_spread({}, playerBitrateLimits), {
                            maxBitRate: maxBitRateCapData.value
                        }));
                    } else {
                        this.logger.warn('SDK.SESSION.SET__MID_STREAM_VIDEO_BITRATE_LIMITS.NOT_SUPPORTED');
                    }
                }
            }
        },
        {
            key: "resetPlayerBitrateLimits",
            value: function resetPlayerBitrateLimits() {
                if (this.isBlockingUserInput()) {
                    this.logger.warn('SDK.SESSION.RESET_VIDEO_BITRATE_LIMITS.INVALID_STATE');
                    return;
                }
                var midStreamCappingSupported = CoreVideoInternal.playerCapabilities.canSetMidStreamPlayerBitrateLimits;
                var maxBitRateCapData = this.bitrateCapManager.getMaxBitRate(Infinity, BitrateCapReason.UserConfiguredCap);
                this.bitrateCapManager.notifyRequestedBitrateCap({
                    value: Infinity,
                    reason: BitrateCapReason.UserConfiguredCap
                });
                if (maxBitRateCapData.currentCapChanged) {
                    this.logger.verbose("resetPlayerBitrateLimits: setting the new bitrate cap: ".concat(maxBitRateCapData.value, " / ").concat(maxBitRateCapData.reason));
                    if (midStreamCappingSupported) {
                        this.bitrateCapManager.notifyAppliedBitrateCap(maxBitRateCapData);
                        if (maxBitRateCapData.value !== Infinity) {
                            var _this_currentPlayerItem;
                            (_this_currentPlayerItem = this.currentPlayerItem) === null || _this_currentPlayerItem === void 0 ? void 0 : _this_currentPlayerItem.setPlayerBitrateLimits({
                                maxBitRate: maxBitRateCapData.value
                            });
                        } else {
                            var _this_currentPlayerItem1;
                            (_this_currentPlayerItem1 = this.currentPlayerItem) === null || _this_currentPlayerItem1 === void 0 ? void 0 : _this_currentPlayerItem1.resetPlayerBitrateLimits();
                        }
                    } else {
                        this.logger.warn('SDK.SESSION.RESET__MID_STREAM_VIDEO_BITRATE_LIMITS.NOT_SUPPORTED');
                    }
                }
            }
        },
        {
            key: "enableSubtitles",
            value: function enableSubtitles(trackId) {
                var _this_currentPlayerItem;
                if (this.isBlockingUserInput()) {
                    this.logger.warn('SDK.SESSION.ENABLE_SUBTITLES.INVALID_STATE');
                    return;
                }
                (_this_currentPlayerItem = this.currentPlayerItem) === null || _this_currentPlayerItem === void 0 ? void 0 : _this_currentPlayerItem.enableSubtitles(trackId);
            }
        },
        {
            key: "disableSubtitles",
            value: function disableSubtitles() {
                var _this_currentPlayerItem;
                if (this.isBlockingUserInput()) {
                    this.logger.warn('SDK.SESSION.DISABLE_SUBTITLES.INVALID_STATE');
                    return;
                }
                (_this_currentPlayerItem = this.currentPlayerItem) === null || _this_currentPlayerItem === void 0 ? void 0 : _this_currentPlayerItem.disableSubtitles();
            }
        },
        {
            key: "getMaxVideoFormat",
            value: function getMaxVideoFormat() {
                var _this_sessionItem_videoFormatConfig_support, _this_sessionItem_videoFormatConfig, _this_sessionItem;
                var _this_sessionItem_videoFormatConfig_support_maxVideoFormat;
                return (_this_sessionItem_videoFormatConfig_support_maxVideoFormat = (_this_sessionItem = this.sessionItem) === null || _this_sessionItem === void 0 ? void 0 : (_this_sessionItem_videoFormatConfig = _this_sessionItem.videoFormatConfig) === null || _this_sessionItem_videoFormatConfig === void 0 ? void 0 : (_this_sessionItem_videoFormatConfig_support = _this_sessionItem_videoFormatConfig.support) === null || _this_sessionItem_videoFormatConfig_support === void 0 ? void 0 : _this_sessionItem_videoFormatConfig_support.maxVideoFormat) !== null && _this_sessionItem_videoFormatConfig_support_maxVideoFormat !== void 0 ? _this_sessionItem_videoFormatConfig_support_maxVideoFormat : VideoFormat.HD;
            }
        },
        {
            key: "getSupportedColourSpaces",
            value: function getSupportedColourSpaces() {
                var _this_sessionItem_videoFormatConfig_support, _this_sessionItem_videoFormatConfig, _this_sessionItem;
                var _this_sessionItem_videoFormatConfig_support_supportedColourSpaces;
                return (_this_sessionItem_videoFormatConfig_support_supportedColourSpaces = (_this_sessionItem = this.sessionItem) === null || _this_sessionItem === void 0 ? void 0 : (_this_sessionItem_videoFormatConfig = _this_sessionItem.videoFormatConfig) === null || _this_sessionItem_videoFormatConfig === void 0 ? void 0 : (_this_sessionItem_videoFormatConfig_support = _this_sessionItem_videoFormatConfig.support) === null || _this_sessionItem_videoFormatConfig_support === void 0 ? void 0 : _this_sessionItem_videoFormatConfig_support.supportedColourSpaces) !== null && _this_sessionItem_videoFormatConfig_support_supportedColourSpaces !== void 0 ? _this_sessionItem_videoFormatConfig_support_supportedColourSpaces : [
                    VideoColourSpace.SDR
                ];
            }
        },
        {
            key: "getSupportedAudioFormats",
            value: function getSupportedAudioFormats() {
                var _CoreVideoInternal_playerCapabilities;
                var _CoreVideoInternal_playerCapabilities_supportedAudioFormats;
                return (_CoreVideoInternal_playerCapabilities_supportedAudioFormats = (_CoreVideoInternal_playerCapabilities = CoreVideoInternal.playerCapabilities) === null || _CoreVideoInternal_playerCapabilities === void 0 ? void 0 : _CoreVideoInternal_playerCapabilities.supportedAudioFormats) !== null && _CoreVideoInternal_playerCapabilities_supportedAudioFormats !== void 0 ? _CoreVideoInternal_playerCapabilities_supportedAudioFormats : [
                    AudioFormat.STEREO
                ];
            }
        },
        {
            key: "getSupportedMaxHdcpLevel",
            value: function getSupportedMaxHdcpLevel() {
                var _CoreVideoInternal_playerCapabilities;
                return (_CoreVideoInternal_playerCapabilities = CoreVideoInternal.playerCapabilities) === null || _CoreVideoInternal_playerCapabilities === void 0 ? void 0 : _CoreVideoInternal_playerCapabilities.supportedMaxHdcpLevel;
            }
        },
        {
            key: "getConnectedHdcpLevel",
            value: function getConnectedHdcpLevel() {
                var _CoreVideoInternal_playerCapabilities;
                return (_CoreVideoInternal_playerCapabilities = CoreVideoInternal.playerCapabilities) === null || _CoreVideoInternal_playerCapabilities === void 0 ? void 0 : _CoreVideoInternal_playerCapabilities.connectedHdcpLevel;
            }
        },
        {
            key: "getWidevineSecurityLevel",
            value: function getWidevineSecurityLevel() {
                var _CoreVideoInternal_playerCapabilities;
                return (_CoreVideoInternal_playerCapabilities = CoreVideoInternal.playerCapabilities) === null || _CoreVideoInternal_playerCapabilities === void 0 ? void 0 : _CoreVideoInternal_playerCapabilities.widevineLevel;
            }
        },
        {
            key: "getSupportedVideoCodecs",
            value: function getSupportedVideoCodecs() {
                var _CoreVideoInternal_playerCapabilities;
                return (_CoreVideoInternal_playerCapabilities = CoreVideoInternal.playerCapabilities) === null || _CoreVideoInternal_playerCapabilities === void 0 ? void 0 : _CoreVideoInternal_playerCapabilities.supportedVideoCodecs;
            }
        },
        {
            key: "setAudioTrack",
            value: function setAudioTrack(trackId) {
                var _this_currentPlayerItem;
                if (this.isBlockingUserInput()) {
                    this.logger.warn('SDK.SESSION.SET_AUDIO_TRACK.INVALID_STATE');
                    return;
                }
                this.audioTrackWillChangeObservable.notifyObservers(trackId);
                (_this_currentPlayerItem = this.currentPlayerItem) === null || _this_currentPlayerItem === void 0 ? void 0 : _this_currentPlayerItem.setAudioTrack(trackId);
            }
        },
        {
            key: "waitForOneOfStates",
            value: function waitForOneOfStates(states) {
                var _this = this;
                if (states.includes(this.currentState)) {
                    return Promise.resolve();
                }
                var callbackOwner = {};
                return new Promise(function(resolve, reject) {
                    _this.sessionStateObservable.registerObserver(function(newState) {
                        if (states.includes(newState)) {
                            resolve();
                            _this.sessionStateObservable.unregisterObservers(callbackOwner);
                            _this.errorObservable.unregisterObservers(callbackOwner);
                        }
                    }, callbackOwner);
                    _this.errorObservable.registerObserver(function(error) {
                        if (error.severity === ErrorSeverity.Fatal) {
                            reject(error);
                            _this.sessionStateObservable.unregisterObservers(callbackOwner);
                            _this.errorObservable.unregisterObservers(callbackOwner);
                        }
                    }, callbackOwner);
                });
            }
        },
        {
            key: "waitForState",
            value: function waitForState(state) {
                return this.waitForOneOfStates([
                    state
                ]);
            }
        },
        {
            key: "getCurrentState",
            value: function getCurrentState() {
                return this.currentState;
            }
        },
        {
            key: "onAdStarted",
            value: function onAdStarted(callback) {
                this.adStartedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onAdFinished",
            value: function onAdFinished(callback) {
                this.adFinishedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onAdBreakStarted",
            value: function onAdBreakStarted(callback) {
                this.adBreakStartedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onAdBreakFinished",
            value: function onAdBreakFinished(callback) {
                this.adBreakFinishedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onAdBreakDataReceived",
            value: function onAdBreakDataReceived(callback) {
                this.adBreakDataReceivedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onAdTrackingReceived",
            value: function onAdTrackingReceived(callback) {
                this.adTrackingReceivedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onCatchupSeek",
            value: function onCatchupSeek(callback) {
                this.catchupSeekObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onVideoElementCreated",
            value: function onVideoElementCreated(callback) {
                this.videoElementCreatedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onFullscreenChanged",
            value: function onFullscreenChanged(callback) {
                this.fullscreenChangedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onClicked",
            value: function onClicked(callback) {
                this.clickedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onQualityFailover",
            value: function onQualityFailover(callback) {
                this.qualityFailoverObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onCdnSwitch",
            value: function onCdnSwitch(callback) {
                this.cdnSwitchObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onStateChanged",
            value: function onStateChanged(callback, priority) {
                this.sessionStateObservable.registerObserver(callback, this, {
                    priority: priority
                });
            }
        },
        {
            key: "onRebufferStart",
            value: function onRebufferStart(callback) {
                var _this_rebufferStartObservable;
                (_this_rebufferStartObservable = this.rebufferStartObservable) === null || _this_rebufferStartObservable === void 0 ? void 0 : _this_rebufferStartObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onRebufferEnd",
            value: function onRebufferEnd(callback) {
                var _this_rebufferEndObservable;
                (_this_rebufferEndObservable = this.rebufferEndObservable) === null || _this_rebufferEndObservable === void 0 ? void 0 : _this_rebufferEndObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onTelemetry",
            value: function onTelemetry(callback) {
                this.telemetryObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onTelemetryUpdate",
            value: function onTelemetryUpdate(callback) {
                this.telemetryUpdateObservable.registerObserver(callback, this);
            }
        },
        {
            key: "updateTelemetryMetrics",
            value: function updateTelemetryMetrics(telemetryData) {
                this.telemetryUpdateObservable.notifyObservers(telemetryData);
            }
        },
        {
            key: "onHttpRequest",
            value: function onHttpRequest(callback) {
                this.httpRequestObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onHttpResponse",
            value: function onHttpResponse(callback) {
                this.httpResponseObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onError",
            value: function onError(callback) {
                this.errorObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onWarning",
            value: function onWarning(callback) {
                this.warningObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onPlaybackTimelineUpdated",
            value: function onPlaybackTimelineUpdated(callback) {
                // @ts-ignore
                this.playbackTimelineObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onAdPositionChanged",
            value: function onAdPositionChanged(callback) {
                this.adPositionObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onPauseAd",
            value: function onPauseAd(callback) {
                this.pauseAdObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onVerifyCompanionAdInsertionEnabled",
            value: function onVerifyCompanionAdInsertionEnabled(callback) {
                this.companionAdInsertionEnabledObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onCompanionAdOpportunityStarted",
            value: function onCompanionAdOpportunityStarted(callback) {
                this.companionAdOpportunityStartedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onCompanionAdOpportunityEnded",
            value: function onCompanionAdOpportunityEnded(callback) {
                this.companionAdOpportunityEndedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onRenderWatermark",
            value: function onRenderWatermark(callback) {
                this.renderWatermarkObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onClearWatermark",
            value: function onClearWatermark(callback) {
                this.clearWatermarkObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onClearWatermarks",
            value: function onClearWatermarks(callback) {
                this.clearWatermarksObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onUserWaitStarted",
            value: function onUserWaitStarted(callback) {
                this.userWaitStartedObservable.registerObserver(function(_, currentPosition, absolutePosition) {
                    return callback(currentPosition, absolutePosition);
                }, this);
            }
        },
        {
            key: "onUserWaitEnded",
            value: function onUserWaitEnded(callback) {
                this.userWaitEndedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onStreamMetadataReceived",
            value: function onStreamMetadataReceived(callback) {
                this.streamMetadataReceivedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onTimedMetadataReceived",
            value: function onTimedMetadataReceived(callback) {
                return this.timedMetadataReceivedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onBulkTimedMetadataReceived",
            value: function onBulkTimedMetadataReceived(callback) {
                this.bulkTimedMetadataReceivedObservable.registerObserver(callback, this, {
                    renotifyLastEvent: true
                });
            }
        },
        {
            key: "onBitrateChanged",
            value: function onBitrateChanged(callback) {
                this.bitrateChangedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onEncodedFrameRateChanged",
            value: function onEncodedFrameRateChanged(callback) {
                this.encodedFrameRateChangedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onRenderedFrameRateChanged",
            value: function onRenderedFrameRateChanged(callback) {
                this.renderedFrameRateChangedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onVideoTrackChanged",
            value: function onVideoTrackChanged(callback) {
                this.videoTrackChangedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onAvailableAudioTracksChanged",
            value: function onAvailableAudioTracksChanged(callback) {
                return this.availableAudioTracksChangedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onAvailableSubtitlesTracksChanged",
            value: function onAvailableSubtitlesTracksChanged(callback) {
                return this.availableSubtitlesTracksChangedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onAvailableThumbnailVariantsChanged",
            value: function onAvailableThumbnailVariantsChanged(callback) {
                this.availableThumbnailVariantsChangedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onAudioTrackWillChange",
            value: function onAudioTrackWillChange(callback) {
                this.audioTrackWillChangeObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onAudioTrackChanged",
            value: function onAudioTrackChanged(callback) {
                this.audioTrackChangedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onBitrateCapChanged",
            value: function onBitrateCapChanged(callback) {
                this.bitrateCapChangedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onBitrateCapRequested",
            value: function onBitrateCapRequested(callback) {
                this.bitrateCapRequestedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onPlayoutDataReceived",
            value: function onPlayoutDataReceived(callback) {
                this.playoutDataObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onPlayoutRulesReceived",
            value: function onPlayoutRulesReceived(callback) {
                this.playoutRulesObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onSubtitlesTrackChanged",
            value: function onSubtitlesTrackChanged(callback) {
                this.subtitlesTrackChangedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onSubtitleCuesChanged",
            value: function onSubtitleCuesChanged(callback) {
                this.subtitleCuesChangedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onPlayStart",
            value: function onPlayStart(callback) {
                this.playStartObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onSeekStarted",
            value: function onSeekStarted(callback) {
                this.seekingManager.onSeekStarted(callback);
            }
        },
        {
            key: "onSeekEnded",
            value: function onSeekEnded(callback) {
                this.seekingManager.onSeekEnded(callback);
            }
        },
        {
            key: "onSessionEnded",
            value: function onSessionEnded(callback) {
                this.sessionEndedObservable.registerObserver(callback, this, {
                    once: true
                });
            }
        },
        {
            key: "onVolumeChanged",
            value: function onVolumeChanged(callback) {
                this.volumeChangedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onMuteChanged",
            value: function onMuteChanged(callback) {
                this.isMutedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onEventBoundary",
            value: function onEventBoundary(callback) {
                this.eventBoundaryObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onEndOfEventMarkerReceived",
            value: function onEndOfEventMarkerReceived(callback) {
                this.endOfEventMarkerReceivedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onManifestReceived",
            value: function onManifestReceived(callback) {
                this.manifestReceivedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onPinRequired",
            value: function onPinRequired(callback) {
                this.pinRequiredObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onPinSuccess",
            value: function onPinSuccess(callback) {
                this.pinSuccessObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onAutoPlayPolicyPreventedPlayback",
            value: function onAutoPlayPolicyPreventedPlayback(callback) {
                this.autoPlayPolicyPreventedPlaybackObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onAssetMetadataUpdated",
            value: function onAssetMetadataUpdated(callback) {
                this.assetMetadataUpdateObservable.registerObserver(callback, this);
            }
        },
        {
            key: "notifySessionEnded",
            value: function notifySessionEnded() {
                var _this_hdcpManager;
                this.sessionEndedObservable.notifyObservers();
                (_this_hdcpManager = this.hdcpManager) === null || _this_hdcpManager === void 0 ? void 0 : _this_hdcpManager.updateComplianceCache();
            }
        },
        {
            key: "notifyEventBoundary",
            value: function notifyEventBoundary(event) {
                this.eventBoundaryObservable.notifyObservers(event);
            }
        },
        {
            key: "notifyEndOfEventMarkerReceived",
            value: function notifyEndOfEventMarkerReceived(eventTime) {
                this.endOfEventMarkerReceivedObservable.notifyObservers(eventTime);
            }
        },
        {
            key: "notifyStreamMetadataReceived",
            value: function notifyStreamMetadataReceived(metadata) {
                this.streamMetadataReceivedObservable.notifyObservers(metadata);
            }
        },
        {
            key: "notifySubtitleCuesChanged",
            value: function notifySubtitleCuesChanged(cues) {
                this.subtitleCuesChangedObservable.notifyObservers(cues);
            }
        },
        {
            key: "notifyTimelineAssetsAvailable",
            value: function notifyTimelineAssetsAvailable(assetGroups) {
                var _this = this;
                this.logger.info('Scheduling linear ads on the timeline:', assetGroups);
                assetGroups.forEach(function(group) {
                    _this.timelineManager.insertAdverts(group);
                });
            }
        },
        {
            key: "notifyAdBreakStarted",
            value: function notifyAdBreakStarted(adBreak) {
                this.adPositionObservable.notifyObservers({
                    adPosition: 0,
                    adBreakPosition: 0,
                    ad: adBreak.ads && adBreak.ads[0],
                    adBreak: adBreak
                });
                this.adBreakStartedObservable.reset();
                this.adBreakStartedObservable.notifyObservers(adBreak);
            }
        },
        {
            key: "notifyAdStarted",
            value: function notifyAdStarted(adData) {
                this.adStartedObservable.reset();
                this.adStartedObservable.notifyObservers(adData);
            }
        },
        {
            key: "notifyAdFinished",
            value: function notifyAdFinished(adData) {
                this.adFinishedObservable.reset();
                this.adFinishedObservable.notifyObservers(adData);
            }
        },
        {
            key: "notifyAdBreakFinished",
            value: function notifyAdBreakFinished(adBreak) {
                this.adBreakFinishedObservable.reset();
                this.adBreakFinishedObservable.notifyObservers(adBreak);
            }
        },
        {
            key: "updatePlayerStartPositionForForcedPrerolls",
            value: function updatePlayerStartPositionForForcedPrerolls() {
                var _this_sessionControllerPrecursor_playoutData, _this_config_addons_adInsertion, // Note: Cover case where add-on is disabled at the session level
                _CoreVideoInternal_config_default_addons_adInsertion, _CoreVideoInternal_config_default_addons_adInsertion_mediaTailor, _CoreVideoInternal_config_default_addons_adInsertion1, // Note: workaround to take place of this.advertsManager.isInitialPositionAdjustmentRequired() due to lack of ssai add-on
                _CoreVideoInternal_config_default_addons_adInsertion_adPolicyConfig, _CoreVideoInternal_config_default_addons_adInsertion2;
                if (typeof ((_this_sessionControllerPrecursor_playoutData = this.sessionControllerPrecursor.playoutData) === null || _this_sessionControllerPrecursor_playoutData === void 0 ? void 0 : _this_sessionControllerPrecursor_playoutData.position) === 'number' && !this.startPositionMoved && checkIsManifestVodType(this.sessionItem.type) && !((_this_config_addons_adInsertion = this.config.addons.adInsertion) === null || _this_config_addons_adInsertion === void 0 ? void 0 : _this_config_addons_adInsertion.enabled) && ((_CoreVideoInternal_config_default_addons_adInsertion = CoreVideoInternal.config.default.addons.adInsertion) === null || _CoreVideoInternal_config_default_addons_adInsertion === void 0 ? void 0 : _CoreVideoInternal_config_default_addons_adInsertion.enabled) && ((_CoreVideoInternal_config_default_addons_adInsertion1 = CoreVideoInternal.config.default.addons.adInsertion) === null || _CoreVideoInternal_config_default_addons_adInsertion1 === void 0 ? void 0 : (_CoreVideoInternal_config_default_addons_adInsertion_mediaTailor = _CoreVideoInternal_config_default_addons_adInsertion1.mediaTailor) === null || _CoreVideoInternal_config_default_addons_adInsertion_mediaTailor === void 0 ? void 0 : _CoreVideoInternal_config_default_addons_adInsertion_mediaTailor.deriveAdInfoFromManifest) && ((_CoreVideoInternal_config_default_addons_adInsertion2 = CoreVideoInternal.config.default.addons.adInsertion) === null || _CoreVideoInternal_config_default_addons_adInsertion2 === void 0 ? void 0 : (_CoreVideoInternal_config_default_addons_adInsertion_adPolicyConfig = _CoreVideoInternal_config_default_addons_adInsertion2.adPolicyConfig) === null || _CoreVideoInternal_config_default_addons_adInsertion_adPolicyConfig === void 0 ? void 0 : _CoreVideoInternal_config_default_addons_adInsertion_adPolicyConfig.alwaysForcePrerolls)) {
                    this.seekingManager.seekToAdjustedStartPosition(this.sessionControllerPrecursor.playoutData.position);
                    this.startPositionMoved = true;
                }
            }
        },
        {
            key: "notifyAdBreakDataReceived",
            value: function notifyAdBreakDataReceived(adBreaks) {
                this.updatePlayerStartPosition();
                var advertising = this.advertsManager.advertisingData;
                if (advertising && !advertising.isKillswitchEnabled && shouldLoadAdvertisingAddons(this.sessionItem)) {
                    this.addonManager.prepareAdvertising(advertising);
                }
                this.adBreakDataReceivedObservable.notifyObservers(this.getAdaptedClientFilteredAdBreakData(adBreaks));
                this.updateSeekableRange();
            }
        },
        {
            key: "notifyAdTrackingReceived",
            value: function notifyAdTrackingReceived(adBreaks) {
                this.adTrackingReceivedObservable.notifyObservers(this.getAdaptedClientFilteredAdBreakData(adBreaks));
            }
        },
        {
            key: "notifyCatchupSeek",
            value: function notifyCatchupSeek(catchupSeek) {
                this.catchupSeekObservable.notifyObservers(catchupSeek);
            }
        },
        {
            key: "getAdaptedClientFilteredAdBreakData",
            value: function getAdaptedClientFilteredAdBreakData(adBreaks) {
                return this.adaptAdBreaksByStreamType(adBreaks.filter(function(adBreak) {
                    return adBreak.ads.length;
                }));
            }
        },
        {
            key: "adaptAdBreaksByStreamType",
            value: function adaptAdBreaksByStreamType(adBreaks) {
                if (checkIsManifestVodType(this.sessionItem.type)) {
                    return this.advertsManager.adaptAdBreaksPositionsToContentTime(adBreaks);
                } else {
                    return adBreaks;
                }
            }
        },
        {
            key: "notifyError",
            value: function notifyError(error) {
                var _this_currentPlayerItem, _this_hdcpManager;
                error = this.sessionControllerPrecursor.adaptPlayerError(error);
                var timeIncludingAds = (_this_currentPlayerItem = this.currentPlayerItem) === null || _this_currentPlayerItem === void 0 ? void 0 : _this_currentPlayerItem.getCurrentPosition();
                if (timeIncludingAds !== undefined) {
                    var contentTime = this.advertsManager.timeIncludingAdsToContentTime(timeIncludingAds);
                    this.logger.breadcrumb("EngineItem Time: ".concat(timeIncludingAds, " | Content Time: ").concat(contentTime));
                }
                if (CoreVideoInternal.lifecycle.isAppBackgrounded()) {
                    error.code = "BACKGROUND.".concat(error.code);
                }
                this.errorObservable.notifyObservers(error);
                if (error.reason === ErrorReason.HDCP) (_this_hdcpManager = this.hdcpManager) === null || _this_hdcpManager === void 0 ? void 0 : _this_hdcpManager.onHdcpError();
            }
        },
        {
            key: "notifyWarning",
            value: function notifyWarning(errorCode, reason) {
                this.warningObservable.notifyObservers(CvsdkError.from({
                    code: errorCode,
                    message: reason,
                    severity: ErrorSeverity.Warning
                }));
            }
        },
        {
            key: "setEventTransformers",
            value: // Create a wrapper for the observable that is able to transform instead of having it in every observable
            function setEventTransformers(eventTransformers) {
                var _this = this;
                this.logger.info('Setting transformers on Session-Proxy events');
                if (eventTransformers.onStateChanged) {
                    eventTransformers.onStateChanged.forEach(function(t) {
                        _this.sessionStateObservable.addTransformer(t);
                    });
                }
                if (eventTransformers.onError) {
                    eventTransformers.onError.forEach(function(t) {
                        _this.errorObservable.addTransformer(t);
                    });
                }
                if (eventTransformers.onSessionEnded) {
                    eventTransformers.onSessionEnded.forEach(function(t) {
                        _this.sessionEndedObservable.addTransformer(t);
                    });
                }
            }
        },
        {
            key: "notifyPauseAd",
            value: function notifyPauseAd(event) {
                this.pauseAdObservable.notifyObservers(event);
            }
        },
        {
            key: "notifyCompanionAdInsertionEnabled",
            value: function notifyCompanionAdInsertionEnabled(companionAdInsertionEnabled) {
                if (!checkIsManifestSingleLiveEventType(this.sessionItem.type)) {
                    this.logger.info('Companion Ad insertion not supported for non SLE streams, notifyCompanionAdInsertionEnabled will return false');
                    this.companionAdInsertionEnabledObservable.notifyObservers(false);
                    return;
                }
                this.logger.info('notifyCompanionAdInsertionEnabled', companionAdInsertionEnabled);
                this.companionAdInsertionEnabledObservable.notifyObservers(companionAdInsertionEnabled);
            }
        },
        {
            key: "notifyCompanionAdOpportunityStarted",
            value: function notifyCompanionAdOpportunityStarted(event) {
                this.logger.info('notifyCompanionAdOpportunityStarted', event);
                this.companionAdOpportunityStartedObservable.notifyObservers(event);
            }
        },
        {
            key: "notifyCompanionAdOpportunityEnded",
            value: function notifyCompanionAdOpportunityEnded(event) {
                this.logger.info('notifyCompanionAdOpportunityEnded', event);
                this.companionAdOpportunityEndedObservable.notifyObservers(event);
            }
        },
        {
            key: "notifyRenderWatermark",
            value: function notifyRenderWatermark(data) {
                this.logger.info('notifyRenderWatermark', data);
                this.renderWatermarkObservable.notifyObservers(data);
            }
        },
        {
            key: "notifyClearWatermark",
            value: function notifyClearWatermark(data) {
                this.logger.info('notifyClearWatermark', data);
                this.clearWatermarkObservable.notifyObservers(data);
            }
        },
        {
            key: "notifyClearWatermarks",
            value: function notifyClearWatermarks() {
                this.logger.info('notifyClearWatermarks');
                this.clearWatermarksObservable.notifyObservers();
            }
        },
        {
            key: "notifyAdPositionChanged",
            value: function notifyAdPositionChanged(adPosition) {
                this.adPositionObservable.notifyObservers(adPosition);
            }
        },
        {
            key: "notifyAssetMetadataUpdated",
            value: function notifyAssetMetadataUpdated(assetMetadata) {
                this.assetMetadataUpdateObservable.notifyObservers(assetMetadata);
            }
        },
        {
            key: "notifyManifestReceived",
            value: function notifyManifestReceived(playerManifestReceivedEvent, timelineItemType) {
                var _this_currentPlayerItem;
                if (timelineItemType) {
                    this.manifestReceivedObservable.notifyObservers({
                        playerManifestReceivedEvent: playerManifestReceivedEvent,
                        timelineItemType: timelineItemType
                    });
                }
                (_this_currentPlayerItem = this.currentPlayerItem) === null || _this_currentPlayerItem === void 0 ? void 0 : _this_currentPlayerItem.setActiveManifest(playerManifestReceivedEvent.manifestResponse.manifest);
            }
        },
        {
            key: "requestSessionStop",
            value: function requestSessionStop(error) {
                var _this = this;
                return _async_to_generator(function() {
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.logger.info("Session stop requested for ".concat(error.message));
                                _this.notifyError(error);
                                return [
                                    4,
                                    _this.stop()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "isFinished",
            value: function isFinished() {
                return FINAL_STATES.includes(this.currentState);
            }
        },
        {
            key: "restartSession",
            value: function restartSession() {
                this.sessionControllerPrecursor.restartSession();
            }
        },
        {
            key: "retrySession",
            value: function retrySession() {
                // Added here for type safety. Implemented in the Chromecast sender session controller only
                this.logger.warn("Method 'retrySession' is not implemented");
            }
        },
        {
            key: "isBlockingUserInput",
            value: function isBlockingUserInput() {
                return _to_consumable_array(INITIAL_STATES).concat(_to_consumable_array(FINAL_STATES)).includes(this.currentState);
            }
        },
        {
            key: "setUserWaitStarted",
            value: function setUserWaitStarted() {
                var _this = this;
                var _this_currentPlayerItem;
                var positionIncludingAds = this.advertsManager.timeIncludingAdsToContentTime((_this_currentPlayerItem = this.currentPlayerItem) === null || _this_currentPlayerItem === void 0 ? void 0 : _this_currentPlayerItem.getCurrentPosition());
                if (this.currentPlayerItem) {
                    this.currentPlayerItem.getLiveWindow().then(function(liveWindow) {
                        _this.userWaitStartedObservable.notifyObservers(undefined, positionIncludingAds, contentTimeToAbsoluteDate(positionIncludingAds, liveWindow !== null && liveWindow !== void 0 ? liveWindow : undefined));
                    });
                } else {
                    this.userWaitStartedObservable.notifyObservers();
                }
            }
        },
        {
            key: "setUserWaitEnded",
            value: function setUserWaitEnded() {
                this.userWaitEndedObservable.notifyObservers();
            }
        },
        {
            key: "cancelPin",
            value: function cancelPin() {
                if (!this.isWaitingForPin) {
                    return;
                }
                this.logger.info('User cancelled entry of PIN');
                this.stop();
                this.destroy();
            }
        },
        {
            key: "setPin",
            value: function setPin(pin) {
                var _this = this;
                return _async_to_generator(function() {
                    var e;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!_this.isWaitingForPin || !('key' in _this.sessionItem)) {
                                    return [
                                        2
                                    ];
                                }
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    4,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    _this.initialisePrecursor(pin)
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    4,
                                    _this.tryPlayout()
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                e = _state.sent();
                                if (_instanceof(e, Error)) {
                                    _this.handleStartError(e);
                                } else {
                                    _this.logger.warn('Expected error to be instanceof Error', e);
                                    _this.handleStartError(e);
                                }
                                return [
                                    3,
                                    5
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "setThumbnailVariant",
            value: function setThumbnailVariant(variantId) {
                if (this.sessionItem.type !== PlaybackType.VOD && this.sessionItem.type !== PlaybackType.Clip && this.sessionItem.type !== PlaybackType.Preview) {
                    this.logger.info("Thumbnails are not currently supported on playback type ".concat(this.sessionItem.type));
                    return Promise.resolve(undefined);
                }
                // All playout types need to be disabled except for VOD/Clip/Preview. We will re-add the SLE thumbnail feature flag when
                // we release the SLE thumbnail feature
                /*
        if (checkIsManifestSingleLiveEventType(this.sessionItem.type)) {
            if (CoreVideoInternal.getPropositionExtensions()?.sleThumbnails?.allowed && this.sessionItem.enableSleThumbnails) {
                this.logger.info('SLE thumbnails are enabled');
            } else {
                return Promise.resolve(undefined);
            }
        }
        */ return this.currentPlayerItem.setThumbnailVariant(variantId);
            }
        },
        {
            key: "getThumbnailForTime",
            value: function getThumbnailForTime(contentTime, velocity) {
                var _this = this;
                return _async_to_generator(function() {
                    var timeIncludingAds, thumbnailRenderInfo, thumbnailInfoUtils;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (_this.isBlockingUserInput()) {
                                    _this.logger.warn('SDK.SESSION.GET_THUMBNAIL.INVALID_STATE');
                                    return [
                                        2,
                                        null
                                    ];
                                }
                                timeIncludingAds = _this.advertsManager.contentTimeToTimeIncludingAds(contentTime);
                                return [
                                    4,
                                    _this.currentPlayerItem.getThumbnailForTime(timeIncludingAds, contentTime, velocity)
                                ];
                            case 1:
                                thumbnailRenderInfo = _state.sent();
                                thumbnailInfoUtils = _this.advertsManager.getThumbnailInfoUtils();
                                if (thumbnailInfoUtils && thumbnailRenderInfo) {
                                    return [
                                        2,
                                        thumbnailInfoUtils.adaptThumbnailPositionsToContentTime(thumbnailRenderInfo)
                                    ];
                                } else {
                                    return [
                                        2,
                                        thumbnailRenderInfo
                                    ];
                                }
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "isSeekToDateSupported",
            value: function isSeekToDateSupported() {
                return checkIsManifestLinearType(this.sessionItem.type);
            }
        },
        {
            key: "notifyAutoPlayPolicyPreventedPlayback",
            value: function notifyAutoPlayPolicyPreventedPlayback() {
                this.autoPlayPolicyPreventedPlaybackObservable.notifyObservers();
            }
        },
        {
            key: "shouldBlockSeekingState",
            value: function shouldBlockSeekingState() {
                var _CoreVideoInternal_playerCapabilities;
                return Boolean((_CoreVideoInternal_playerCapabilities = CoreVideoInternal.playerCapabilities) === null || _CoreVideoInternal_playerCapabilities === void 0 ? void 0 : _CoreVideoInternal_playerCapabilities.hasSeekingStateSupport) && (this.preSeekLock.locked || this.currentState === InternalSessionState.Seeking);
            }
        },
        {
            key: "callSeekOnTimelineManager",
            value: function callSeekOnTimelineManager(seekTo) {
                this.timelineManager.seek(seekTo);
            }
        },
        {
            key: "calculateUserSeekedFromLiveEdge",
            value: function calculateUserSeekedFromLiveEdge(isCurrentlyAtLiveEdge) {
                // If content is playing and the player is currently at the live edge, then the user has either not seeked
                // or seeked back back to live edge range
                if (this.currentState === InternalSessionState.Playing && isCurrentlyAtLiveEdge) {
                    this.hasSeekedFromLiveEdge = false;
                } else // If the session is paused, the user may have fallen out of the live edge
                // In this case, the user is considered to have seeked away from the live edge
                if (this.currentState === InternalSessionState.Paused && !isCurrentlyAtLiveEdge) {
                    this.hasSeekedFromLiveEdge = true;
                }
                this.logger.verbose("Has seeked from live edge: ".concat(this.hasSeekedFromLiveEdge));
            }
        },
        {
            key: "handleStartError",
            value: function handleStartError(e) {
                this.logger.error('SessionController::start', e);
                if (_instanceof(e, CvsdkError)) {
                    this.errorObservable.notifyObservers(e);
                } else if ('code' in e) {
                    this.logger.warn('Expected error to be instanceof CvsdkError', e);
                    this.errorObservable.notifyObservers(e);
                } else {
                    this.errorObservable.notifyObservers(CvsdkError.from({
                        code: 'SESSION.START_FAILURE',
                        message: 'Error starting session',
                        cause: e,
                        severity: ErrorSeverity.Fatal
                    }));
                }
                this.destroy();
            }
        },
        {
            key: "initialisePrecursor",
            value: function initialisePrecursor(pin) {
                var _this = this;
                return _async_to_generator(function() {
                    var e, pinCause;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _this.sessionControllerPrecursor.initialise(pin)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                e = _state.sent();
                                pinCause = PLAYOUT_ERROR_TO_PIN_CAUSE[e === null || e === void 0 ? void 0 : e.code];
                                if (pinCause) {
                                    _this.isWaitingForPin = true;
                                    _this.pinRequiredObservable.reset();
                                    _this.pinRequiredObservable.notifyObservers(pinCause);
                                    perfLogger.measure(PerfKey.core, PerfTag.pinRequired);
                                } else {
                                    throw e;
                                }
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "shouldDisablePip",
            value: function shouldDisablePip() {
                return Boolean(this.addonManager.isWatermarkingEnabled() || this.sessionItem.isMultiview);
            }
        },
        {
            key: "tryPlayout",
            value: function tryPlayout() {
                var _this = this;
                return _async_to_generator(function() {
                    var playoutData, mainAsset, colourSpaceSuccess, advertising;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                playoutData = _this.sessionControllerPrecursor.playoutData;
                                mainAsset = _this.sessionControllerPrecursor.mainAsset;
                                if (!playoutData || !mainAsset) {
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    4,
                                    _this.activateColourSpace(playoutData)
                                ];
                            case 1:
                                colourSpaceSuccess = _state.sent();
                                if (!colourSpaceSuccess) {
                                    return [
                                        2
                                    ];
                                }
                                _this.addonManager.lazyLoad(CoreVideoInternal.playerCapabilities, playoutData);
                                // load addons dependent on PlayoutData (e.g. watermarking for browser)
                                _this.timelineManager.initializeTimeline(mainAsset, _this.advertsManager.getAdvertBoltOns(), _this.sessionControllerPrecursor.getDRMBoltOns(), _this.advertsManager.getAdInsertionConfig());
                                if (_this.isWaitingForPin) {
                                    _this.pinSuccessObservable.notifyObservers();
                                    perfLogger.measure(PerfKey.core, PerfTag.pinSuccess);
                                }
                                advertising = _this.advertsManager.advertisingData;
                                if (!(advertising && !advertising.isKillswitchEnabled && shouldLoadAdvertisingAddons(_this.sessionItem))) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    _this.setupAds(advertising)
                                ];
                            case 2:
                                _state.sent();
                                _state.label = 3;
                            case 3:
                                perfLogger.measure(PerfKey.root, PerfTag.startingTimeline);
                                return [
                                    4,
                                    _this.timelineManager.startTimeline(playoutData.position)
                                ];
                            case 4:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "activateColourSpace",
            value: function activateColourSpace(playoutData) {
                var _this = this;
                return _async_to_generator(function() {
                    var _this_sessionItem_display, display, _playoutData_stream, _playoutData_stream_colourSpace, colourSpace, colourSpaceActivated, colourSpaceString, code, message;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                display = CoreVideoInternal.display;
                                if (!(display === null || display === void 0 ? void 0 : display.activateColourSpace) || !((_this_sessionItem_display = _this.sessionItem.display) === null || _this_sessionItem_display === void 0 ? void 0 : _this_sessionItem_display.playerViewAlwaysPresentedFullScreen)) {
                                    return [
                                        2,
                                        true
                                    ];
                                }
                                _playoutData_stream = playoutData.stream, _playoutData_stream_colourSpace = _playoutData_stream.colourSpace, colourSpace = _playoutData_stream_colourSpace === void 0 ? VideoColourSpace.SDR : _playoutData_stream_colourSpace;
                                return [
                                    4,
                                    display.activateColourSpace(ClientVideoColourSpace[VideoColourSpace[colourSpace]])
                                ];
                            case 1:
                                colourSpaceActivated = _state.sent();
                                if (colourSpaceActivated) {
                                    return [
                                        2,
                                        true
                                    ];
                                }
                                colourSpaceString = typeof colourSpace === 'string' ? colourSpace : VideoColourSpace[colourSpace];
                                code = "".concat(COLOUR_SPACE_ACTIVATION_ERROR_PREFIX, ".").concat(colourSpaceString);
                                message = "Failed to activate ".concat(colourSpaceString, " colour space");
                                // We should avoid notifying an error if we are trying to switch to SDR and it fails because
                                // there is nothing we can fallback to so we have to just play anyway. Otherwise we risk a loop where
                                // SDR activation fails to we fallback to SDR and try again.
                                if (colourSpace === VideoColourSpace.SDR) {
                                    _this.notifyWarning(code, message);
                                    return [
                                        2,
                                        true
                                    ];
                                }
                                _this.notifyError(CvsdkError.from({
                                    code: code,
                                    message: message,
                                    severity: ErrorSeverity.Fatal
                                }));
                                return [
                                    4,
                                    _this.destroy()
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    2,
                                    false
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "processVodAdverts",
            value: function processVodAdverts() {
                var _this = this;
                return _async_to_generator(function() {
                    var advertGroups;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!!CoreVideoInternal.playerCapabilities.supportsNativeCsai) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.advertsManager.getVodAdverts()
                                ];
                            case 1:
                                advertGroups = _state.sent();
                                advertGroups.forEach(function(group) {
                                    _this.timelineManager.insertAdverts(group);
                                });
                                _state.label = 2;
                            case 2:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "setupAds",
            value: function setupAds(advertising) {
                var _this = this;
                return _async_to_generator(function() {
                    var e, error;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                _this.addonManager.prepareAdvertising(advertising);
                                return [
                                    4,
                                    _this.processVodAdverts()
                                ];
                            case 1:
                                _state.sent();
                                perfLogger.measure(PerfKey.root, PerfTag.advertisingReady);
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                e = _state.sent();
                                error = e;
                                if (!_instanceof(e, CvsdkError)) {
                                    error = CvsdkError.from({
                                        code: 'SDK.SESSION.ADS_SETUP',
                                        message: 'Error starting session',
                                        severity: ErrorSeverity.Warning,
                                        cause: e,
                                        category: AddonErrorCategory.CsaiAdRequest
                                    });
                                }
                                _this.errorObservable.notifyObservers(error);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "setSessionState",
            value: function setSessionState(state) {
                var _this_currentPlayerItem;
                var oldState = this.currentState;
                this.currentState = state;
                this.logger.verbose('Session state changed from "'.concat(oldState, '" to "').concat(this.currentState, '"'));
                var notifiedState = this.sessionStateObservable.notifyObservers(this.currentState, this.advertsManager.timeIncludingAdsToContentTime((_this_currentPlayerItem = this.currentPlayerItem) === null || _this_currentPlayerItem === void 0 ? void 0 : _this_currentPlayerItem.getCurrentPosition()));
                if (notifiedState === OBSERVABLE_IGNORE_EVENT) {
                    return undefined;
                }
                return notifiedState;
            }
        },
        {
            key: "tryStartCoordinatedBitrateCapping",
            value: function tryStartCoordinatedBitrateCapping(playerEngineItem, timelineItem) {
                var _this = this;
                var _TestingOverrides_coordinatedBitrateCap;
                if (!this.sessionItem.disableCoordinatedBitrateCapping && CoreVideoInternal.playerCapabilities.canSetMidStreamPlayerBitrateLimits && CoreVideoInternal.getPropositionExtensions().coordinatedBitrateCapping && (playerEngineItem.playoutData.type === PlaybackType.SingleLiveEvent || ((_TestingOverrides_coordinatedBitrateCap = TestingOverrides.coordinatedBitrateCap) === null || _TestingOverrides_coordinatedBitrateCap === void 0 ? void 0 : _TestingOverrides_coordinatedBitrateCap.allowAnyAssetType) === true)) {
                    var callbackOwner = this.bitrateCapManager;
                    this.sessionStateObservable.registerObserver(function(newState) {
                        if (newState === InternalSessionState.Playing) {
                            var _this_config_metalist_bitrateCapping, _this_config_metalist;
                            _this.sessionStateObservable.unregisterObservers(callbackOwner);
                            if (!((_this_config_metalist = _this.config.metalist) === null || _this_config_metalist === void 0 ? void 0 : (_this_config_metalist_bitrateCapping = _this_config_metalist.bitrateCapping) === null || _this_config_metalist_bitrateCapping === void 0 ? void 0 : _this_config_metalist_bitrateCapping.useNewBitrateEndpoint)) {
                                _this.bitrateCapManager.setLegacyPrimaryCdn(playerEngineItem.playoutData.cdns[0]);
                                _this.bitrateCapManager.legacyCapInstructionPollingCycleHandler(_this.sessionControllerPrecursor.playoutData.cdns, _this.setPlayerBitrateLimitsWithReason.bind(_this));
                            } else if (_this.metaListManager) {
                                _this.bitrateCapManager.start(_this.setPlayerBitrateLimitsWithReason.bind(_this), _this.metaListManager, _this.sessionControllerPrecursor.playoutData.cdns);
                            }
                        }
                    }, callbackOwner);
                }
                if (timelineItem.type === TimelineItemType.MainContent && Object.keys(this.playerBitrateLimits).length && CoreVideoInternal.playerCapabilities.canSetPlayerBitrateLimits) {
                    var _playerEngineItem_playoutData_playerBitrateLimits;
                    var maxBitRateCapData = this.bitrateCapManager.getMaxBitRate(this.playerBitrateLimits.maxBitRate, BitrateCapReason.UserConfiguredCap);
                    var _playerEngineItem_playoutData_playerBitrateLimits_maxBitRate;
                    this.bitrateCapManager.notifyRequestedBitrateCap({
                        value: (_playerEngineItem_playoutData_playerBitrateLimits_maxBitRate = (_playerEngineItem_playoutData_playerBitrateLimits = playerEngineItem.playoutData.playerBitrateLimits) === null || _playerEngineItem_playoutData_playerBitrateLimits === void 0 ? void 0 : _playerEngineItem_playoutData_playerBitrateLimits.maxBitRate) !== null && _playerEngineItem_playoutData_playerBitrateLimits_maxBitRate !== void 0 ? _playerEngineItem_playoutData_playerBitrateLimits_maxBitRate : Infinity,
                        reason: BitrateCapReason.UserConfiguredCap
                    });
                    this.bitrateCapManager.notifyAppliedBitrateCap(maxBitRateCapData);
                }
            }
        },
        {
            key: "tryEnableLiveActions",
            value: function tryEnableLiveActions(playerEngineItem) {
                var _this_config_metalist_liveActions, _this_config_metalist;
                if (((_this_config_metalist = this.config.metalist) === null || _this_config_metalist === void 0 ? void 0 : (_this_config_metalist_liveActions = _this_config_metalist.liveActions) === null || _this_config_metalist_liveActions === void 0 ? void 0 : _this_config_metalist_liveActions.enableLiveActions) && !this.liveActionsStarted && !this.isInCSAIPreRoll() && playerEngineItem.playoutData.type === PlaybackType.SingleLiveEvent && this.metaListManager) {
                    var _this_liveActionManager;
                    (_this_liveActionManager = this.liveActionManager) === null || _this_liveActionManager === void 0 ? void 0 : _this_liveActionManager.start(this.registerCue.bind(this), this.metaListManager, this.sessionControllerPrecursor.playoutData.cdns);
                    this.liveActionsStarted = true;
                }
            }
        },
        {
            key: "notifyCachedPreloadEvents",
            value: function notifyCachedPreloadEvents(playerEngineItem) {
                // If the main item was pre-loaded we need to emit the events that were emitted during the loading stage
                if (playerEngineItem.availableAudioTracks) {
                    this.notifyAvailableAudioTracksChanged(playerEngineItem.availableAudioTracks);
                }
                if (playerEngineItem.availableTextTracks) {
                    this.notifyAvailableSubtitlesTracksChanged(playerEngineItem.availableTextTracks);
                }
                if (playerEngineItem.duration) {
                    this.handleDurationChange(playerEngineItem.duration);
                }
                if (playerEngineItem.currentBitrate) {
                    this.bitrateChangedObservable.notifyObservers(playerEngineItem.currentBitrate);
                }
                if (playerEngineItem.currentEncodedFrameRate) {
                    this.encodedFrameRateChangedObservable.notifyObservers(playerEngineItem.currentEncodedFrameRate);
                }
                if (playerEngineItem.currentRenderedFrameRate) {
                    this.renderedFrameRateChangedObservable.notifyObservers(playerEngineItem.currentRenderedFrameRate);
                }
            }
        },
        {
            key: "handleTimelineItemStarted",
            value: /*
     * TimelineManager event handlers
     */ function handleTimelineItemStarted(param) {
                var timelineItem = param.timelineItem, playerEngineItem = param.playerEngineItem;
                var _this_metaListManager;
                this.currentPlayerItem = playerEngineItem;
                this.currentTimelineItem = timelineItem;
                this.registerPlayerObservers(playerEngineItem, timelineItem);
                this.seekingManager.setPlayerEngineItem(playerEngineItem);
                if (timelineItem.type === TimelineItemType.MainContent && playerEngineItem.playoutData.adsFailoverReason) {
                    var _this_advertsManager;
                    this.logger.warn('Destroying adverts manager due to failover');
                    (_this_advertsManager = this.advertsManager) === null || _this_advertsManager === void 0 ? void 0 : _this_advertsManager.destroy();
                }
                if (timelineItem.type === TimelineItemType.MainContent && !this.telemetrySession.isInitialised) {
                    this.telemetrySession.initialise(function() {
                        return playerEngineItem.getTelemetryData();
                    });
                }
                this.logger.verbose("playerCapabilities: ".concat(JsonUtils.stringify(CoreVideoInternal.playerCapabilities)));
                (_this_metaListManager = this.metaListManager) === null || _this_metaListManager === void 0 ? void 0 : _this_metaListManager.setPrimaryCdn(playerEngineItem.playoutData.cdns[0]);
                this.tryStartCoordinatedBitrateCapping(playerEngineItem, timelineItem);
                if (timelineItem.type === TimelineItemType.MainContent && timelineItem.isPreloaded) {
                    this.notifyCachedPreloadEvents(playerEngineItem);
                }
            }
        },
        {
            key: "handleTimelineItemEnded",
            value: function handleTimelineItemEnded() {
                var _this_currentPlayerItem, _this_currentPlayerItem1, _this_metaListManager;
                (_this_currentPlayerItem = this.currentPlayerItem) === null || _this_currentPlayerItem === void 0 ? void 0 : _this_currentPlayerItem.removeEventListeners(this);
                (_this_currentPlayerItem1 = this.currentPlayerItem) === null || _this_currentPlayerItem1 === void 0 ? void 0 : _this_currentPlayerItem1.removeEventListeners(this.currentPlayerItem);
                this.currentPlayerItem = undefined;
                this.currentTimelineItem = undefined;
                this.bitrateCapManager.stopCapInstructionPolling();
                (_this_metaListManager = this.metaListManager) === null || _this_metaListManager === void 0 ? void 0 : _this_metaListManager.destroy();
            }
        },
        {
            key: "handleTimelineItemPreloading",
            value: function handleTimelineItemPreloading(param) {
                var timelineItem = param.timelineItem, playerEngineItem = param.playerEngineItem;
                playerEngineItem.onManifestReceived(this.createManifestReceivedHandler(timelineItem.type), this);
            }
        },
        {
            key: "notifyQualityFailover",
            value: function notifyQualityFailover(event) {
                this.qualityFailoverObservable.notifyObservers(event);
            }
        },
        {
            key: "notifyCdnSwitch",
            value: function notifyCdnSwitch(event) {
                this.cdnSwitchObservable.notifyObservers(event);
            }
        },
        {
            key: "notifyPlayoutDataReceived",
            value: function notifyPlayoutDataReceived(playoutData) {
                this.playoutDataObservable.notifyObservers(playoutData);
            }
        },
        {
            key: "notifyPlayoutRulesReceived",
            value: function notifyPlayoutRulesReceived(playoutRules) {
                this.playoutRulesObservable.notifyObservers(playoutRules);
            }
        },
        {
            key: "handlePlayerEvent",
            value: /*
     *  Player item event handlers
     */ function handlePlayerEvent(observable, event) {
                observable.notifyObservers(event);
            }
        },
        {
            key: "errorTransformer",
            value: function errorTransformer(error) {
                var adaptedError = error;
                if ((adaptedError === null || adaptedError === void 0 ? void 0 : adaptedError.severity) === ErrorSeverity.Fatal) {
                    if ([
                        InternalSessionState.Initialized,
                        InternalSessionState.Loading,
                        InternalSessionState.PlayerLoading
                    ].includes(this.currentState)) {
                        Object.assign(adaptedError, {
                            code: "VSF:".concat(adaptedError === null || adaptedError === void 0 ? void 0 : adaptedError.code),
                            category: PlayerErrorCategory.VSF
                        });
                    } else {
                        Object.assign(adaptedError, {
                            category: PlayerErrorCategory.VPF
                        });
                    }
                }
                return adaptedError;
            }
        },
        {
            key: "handleErrorReceived",
            value: function handleErrorReceived(observable, error) {
                observable.notifyObservers(error);
            }
        },
        {
            key: "handleRebufferEnd",
            value: function handleRebufferEnd() {
                if (this.currentState === InternalSessionState.Rebuffering) {
                    perfLogger.measure(PerfKey.playerState, PerfTag.rebufferEnd);
                    this.notifyRebufferEnd();
                }
            }
        },
        {
            key: "isMainContentCsai",
            value: function isMainContentCsai(playoutData) {
                var _this_currentTimelineItem;
                return isMultiplayerCsai(playoutData) && ((_this_currentTimelineItem = this.currentTimelineItem) === null || _this_currentTimelineItem === void 0 ? void 0 : _this_currentTimelineItem.type) === TimelineItemType.MainContent;
            }
        },
        {
            key: "updateSeekableRange",
            value: function updateSeekableRange() {
                var cachedEngineItemDuration = this.cachedEngineItemDuration;
                if (!cachedEngineItemDuration) {
                    return;
                }
                if (checkIsManifestVodType(this.sessionItem.type)) {
                    var contentDuration = this.advertsManager.timeIncludingAdsToContentTime(cachedEngineItemDuration);
                    this.playbackTimelineObservable.notifyObservers({
                        seekableRange: {
                            start: 0,
                            end: contentDuration
                        }
                    });
                }
            }
        },
        {
            key: "handleTimelineFinished",
            value: function handleTimelineFinished() {
                this.setSessionState(InternalSessionState.Finished);
            }
        },
        {
            key: "normalizeAdBreakPosition",
            value: function normalizeAdBreakPosition(adBreak) {
                var isVod = checkIsManifestVodType(this.sessionItem.type);
                if (isVod) {
                    adBreak = this.advertsManager.adBreakPositionIncludingAdsToContentPosition(adBreak);
                }
                return adBreak;
            }
        },
        {
            key: "handleAdBreakStarted",
            value: function handleAdBreakStarted(adBreak) {
                this.notifyAdBreakStarted(this.normalizeAdBreakPosition(adBreak));
            }
        },
        {
            key: "handleAdBreakFinished",
            value: function handleAdBreakFinished(adBreak) {
                this.notifyAdBreakFinished(this.normalizeAdBreakPosition(adBreak));
            }
        },
        {
            key: "handleManifestParsed",
            value: function handleManifestParsed() {
                perfLogger.measure(PerfKey.root, PerfTag.manifestParsed);
            }
        },
        {
            key: "calculateIfAtLiveEdge",
            value: function calculateIfAtLiveEdge(liveWindow, position) {
                var drift = liveWindow.end - position;
                return drift <= this.sessionItem.liveEdgeToleranceSeconds;
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                var _this = this;
                return _async_to_generator(function() {
                    var _this_metaListManager, _this_currentPlayerItem, _this_currentPlayerItem1, _this_eventManager_destroy, _this_eventManager, _CoreVideoInternal_display_resetDisplay, _CoreVideoInternal_display, adaptedState;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (_this.currentState === InternalSessionState.Stopped) {
                                    return [
                                        2
                                    ];
                                }
                                adaptedState = _this.setSessionState(InternalSessionState.Stopped);
                                if (adaptedState === InternalSessionState.Stopped) {
                                    _this.notifySessionEnded();
                                }
                                _this.bitrateCapManager.destroy();
                                (_this_metaListManager = _this.metaListManager) === null || _this_metaListManager === void 0 ? void 0 : _this_metaListManager.destroy();
                                _this.telemetrySession.destroy();
                                _this.preSeekLock.destroy();
                                (_this_currentPlayerItem = _this.currentPlayerItem) === null || _this_currentPlayerItem === void 0 ? void 0 : _this_currentPlayerItem.removeEventListeners(_this);
                                (_this_currentPlayerItem1 = _this.currentPlayerItem) === null || _this_currentPlayerItem1 === void 0 ? void 0 : _this_currentPlayerItem1.removeEventListeners(_this.currentPlayerItem);
                                _this.timelineManager.removeEventListeners(_this);
                                _this.addonManager.destroy();
                                (_this_eventManager = _this.eventManager) === null || _this_eventManager === void 0 ? void 0 : (_this_eventManager_destroy = _this_eventManager.destroy) === null || _this_eventManager_destroy === void 0 ? void 0 : _this_eventManager_destroy.call(_this_eventManager);
                                _this.logger.breadcrumb('Session ended');
                                _this.unregisterSessionObservers();
                                _this.videoElementCreatedObservable.reset();
                                _this.seekingManager.destroy();
                                return [
                                    4,
                                    (_CoreVideoInternal_display = CoreVideoInternal.display) === null || _CoreVideoInternal_display === void 0 ? void 0 : (_CoreVideoInternal_display_resetDisplay = _CoreVideoInternal_display.resetDisplay) === null || _CoreVideoInternal_display_resetDisplay === void 0 ? void 0 : _CoreVideoInternal_display_resetDisplay.call(_CoreVideoInternal_display)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "unregisterSessionObservers",
            value: function unregisterSessionObservers() {
                this.sessionStateObservable.unregisterObservers(this);
                this.telemetryObservable.unregisterObservers(this);
                this.telemetryUpdateObservable.unregisterObservers(this);
                this.httpRequestObservable.unregisterObservers(this);
                this.httpResponseObservable.unregisterObservers(this);
                this.playStartObservable.unregisterObservers(this);
                this.playbackTimelineObservable.unregisterObservers(this);
                this.errorObservable.unregisterObservers(this);
                this.warningObservable.unregisterObservers(this);
                this.streamMetadataReceivedObservable.unregisterObservers(this);
                this.bitrateChangedObservable.unregisterObservers(this);
                this.bitrateCapChangedObservable.unregisterObservers(this);
                this.bitrateCapRequestedObservable.unregisterObservers(this);
                this.encodedFrameRateChangedObservable.unregisterObservers(this);
                this.renderedFrameRateChangedObservable.unregisterObservers(this);
                this.videoTrackChangedObservable.unregisterObservers(this);
                this.availableAudioTracksChangedObservable.unregisterObservers(this);
                this.availableSubtitlesTracksChangedObservable.unregisterObservers(this);
                this.availableThumbnailVariantsChangedObservable.unregisterObservers(this);
                this.audioTrackChangedObservable.unregisterObservers(this);
                this.playoutDataObservable.unregisterObservers(this);
                this.playoutRulesObservable.unregisterObservers(this);
                this.subtitlesTrackChangedObservable.unregisterObservers(this);
                this.subtitleCuesChangedObservable.unregisterObservers(this);
                this.volumeChangedObservable.unregisterObservers(this);
                this.eventBoundaryObservable.unregisterObservers(this);
                this.manifestReceivedObservable.unregisterObservers(this);
                this.pinRequiredObservable.unregisterObservers(this);
                this.autoPlayPolicyPreventedPlaybackObservable.unregisterObservers(this);
                this.userWaitStartedObservable.unregisterObservers(this);
                this.userWaitEndedObservable.unregisterObservers(this);
                this.pinSuccessObservable.unregisterObservers(this);
                this.endOfEventMarkerReceivedObservable.unregisterObservers(this);
                this.assetMetadataUpdateObservable.unregisterObservers(this);
                this.pauseAdObservable.unregisterObservers(this);
                this.companionAdInsertionEnabledObservable.unregisterObservers(this);
                this.companionAdOpportunityStartedObservable.unregisterObservers(this);
                this.companionAdOpportunityEndedObservable.unregisterObservers(this);
                this.qualityFailoverObservable.unregisterObservers(this);
                this.cdnSwitchObservable.unregisterObservers(this);
                this.adBreakDataReceivedObservable.unregisterObservers(this);
                this.adTrackingReceivedObservable.unregisterObservers(this);
                this.catchupSeekObservable.unregisterObservers(this);
                this.adBreakFinishedObservable.unregisterObservers(this);
                this.adBreakStartedObservable.unregisterObservers(this);
                this.adFinishedObservable.unregisterObservers(this);
                this.adStartedObservable.unregisterObservers(this);
                this.isMutedObservable.unregisterObservers(this);
                this.audioTrackWillChangeObservable.unregisterObservers(this);
                this.timedMetadataReceivedObservable.unregisterObservers(this);
                this.bulkTimedMetadataReceivedObservable.unregisterObservers(this);
                this.adPositionObservable.unregisterObservers(this);
                this.sessionEndedObservable.unregisterObservers(this);
                this.videoElementCreatedObservable.unregisterObservers(this);
                this.fullscreenChangedObservable.unregisterObservers(this);
                this.clickedObservable.unregisterObservers(this);
                this.rebufferStartObservable.unregisterObservers(this);
                this.rebufferEndObservable.unregisterObservers(this);
            }
        }
    ]);
    return SessionControllerInternal;
}();

//# sourceMappingURL=session-controller-internal.js.map